import * as React from 'react';

import { mergeClassNames } from '@/lib/utils';

const UnionPattern = ({ className, ...props }: React.ComponentProps<'svg'>) => (
  <svg
    viewBox="0 -120 580 328"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={mergeClassNames('h-[328px] w-[580px]', className)}
    {...props}
  >
    <path
      d="M265.951 -118.808L264.84 -120L253.152 -109.103L254.269 -107.906L265.951 -118.808Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.511 -118.8L277.393 -120L265.63 -109.033L266.754 -107.828L278.511 -118.8Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.071 -118.804L289.957 -120L278.233 -109.07L279.354 -107.868L291.071 -118.804Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.391 -118.826L252.297 -119.999L240.791 -109.272L241.89 -108.093L253.391 -118.826Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.633 -118.82L302.533 -119.999L290.958 -109.209L292.064 -108.023L303.633 -118.82Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.194 -118.843L315.117 -119.998L303.787 -109.435L304.87 -108.274L316.194 -118.843Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.832 -118.853L239.763 -119.998L228.526 -109.522L229.599 -108.37L240.832 -118.853Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.272 -118.886L227.235 -119.997L216.332 -109.833L217.374 -108.714L228.272 -118.886Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.756 -118.874L327.709 -119.997L316.695 -109.729L317.747 -108.599L328.756 -118.874Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.318 -118.911L340.306 -119.996L329.661 -110.072L330.678 -108.981L341.318 -118.911Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.712 -118.923L214.712 -119.996L204.193 -110.188L205.198 -109.11L215.712 -118.923Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.153 -118.964L202.193 -119.995L192.092 -110.577L193.057 -109.542L203.153 -118.964Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.88 -118.951L352.906 -119.995L342.67 -110.452L343.648 -109.402L353.88 -118.951Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.441 -118.994L365.51 -119.993L355.71 -110.857L356.647 -109.852L366.441 -118.994Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.595 -119.008L189.677 -119.993L180.02 -110.989L180.942 -109.999L190.595 -119.008Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.003 -119.039L378.115 -119.992L368.773 -111.282L369.666 -110.324L379.003 -119.039Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.035 -119.054L177.161 -119.991L167.967 -111.419L168.846 -110.477L178.035 -119.054Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.566 -119.086L390.723 -119.99L381.853 -111.721L382.701 -110.812L391.566 -119.086Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.476 -119.1L164.648 -119.989L155.931 -111.862L156.764 -110.969L165.476 -119.1Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.128 -119.134L403.331 -119.989L394.947 -112.172L395.748 -111.312L404.128 -119.134Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.918 -119.149L152.136 -119.988L143.906 -112.316L144.692 -111.472L152.918 -119.149Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.69 -119.182L415.94 -119.987L408.049 -112.631L408.803 -111.821L416.69 -119.182Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.359 -119.198L139.624 -119.986L131.891 -112.777L132.63 -111.984L140.359 -119.198Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.8 -119.247L127.113 -119.985L119.883 -113.244L120.574 -112.502L127.8 -119.247Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.253 -119.232L428.55 -119.985L421.16 -113.095L421.866 -112.338L429.253 -119.232Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.814 -119.282L441.16 -119.983L434.277 -113.566L434.935 -112.861L441.814 -119.282Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.241 -119.298L114.603 -119.983L107.88 -113.716L108.523 -113.027L115.241 -119.298Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.377 -119.332L453.772 -119.982L447.399 -114.041L448.008 -113.388L454.377 -119.332Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.683 -119.348L102.092 -119.981L95.8828 -114.192L96.4757 -113.555L102.683 -119.348Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1237 -119.399L89.5829 -119.979L83.8891 -114.671L84.4329 -114.087L90.1237 -119.399Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.939 -119.382L466.382 -119.979L460.526 -114.519L461.085 -113.919L466.939 -119.382Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.501 -119.434L478.994 -119.978L473.655 -115.001L474.165 -114.453L479.501 -119.434Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5654 -119.45L77.0734 -119.977L71.8984 -115.153L72.3931 -114.622L77.5654 -119.45Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.064 -119.485L491.606 -119.976L486.788 -115.484L487.248 -114.99L492.064 -119.485Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0062 -119.501L64.5639 -119.976L59.9107 -115.637L60.3548 -115.161L65.0062 -119.501Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.627 -119.536L504.218 -119.974L499.923 -115.97L500.333 -115.529L504.627 -119.536Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4476 -119.553L52.055 -119.973L47.9251 -116.123L48.3198 -115.7L52.4476 -119.553Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.189 -119.588L516.83 -119.973L513.06 -116.457L513.42 -116.071L517.189 -119.588Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.889 -119.605L39.5464 -119.972L35.942 -116.612L36.2863 -116.242L39.889 -119.605Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.751 -119.64L529.443 -119.971L526.199 -116.946L526.509 -116.613L529.751 -119.64Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3304 -119.656L27.0375 -119.97L23.9597 -117.101L24.2537 -116.786L27.3304 -119.656Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.314 -119.692L542.055 -119.969L539.339 -117.436L539.598 -117.158L542.314 -119.692Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7712 -119.708L14.5286 -119.968L11.9789 -117.591L12.2227 -117.33L14.7712 -119.708Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21286 -119.76L2.02064 -119.967L0 -118.083L0.193117 -117.876L2.21286 -119.76Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.876 -119.744L554.668 -119.967L552.48 -117.927L552.689 -117.703L554.876 -119.744Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.438 -119.796L567.281 -119.966L565.623 -118.419L565.781 -118.25L567.438 -119.796Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 -119.837L579.882 -119.964L578.641 -118.807L578.759 -118.68L580 -119.837Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.953 -106.295L264.892 -107.433L253.732 -97.0292L254.798 -95.8852L265.953 -106.295Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.513 -106.289L277.446 -107.433L266.223 -96.971L267.296 -95.8204L278.513 -106.289Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.074 -106.293L290.01 -107.433L278.821 -97.0014L279.89 -95.8541L291.074 -106.293Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.634 -106.305L302.583 -107.433L291.518 -97.1172L292.576 -95.9831L303.634 -106.305Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.393 -106.31L252.346 -107.433L241.338 -97.1708L242.391 -96.0422L253.393 -106.31Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.196 -106.325L315.163 -107.432L304.306 -97.3103L305.344 -96.1968L316.196 -106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.833 -106.333L239.808 -107.432L229.031 -97.3842L230.061 -96.2799L240.833 -106.333Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.273 -106.362L227.277 -107.431L216.794 -97.6581L217.795 -96.5834L228.273 -106.362Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.757 -106.352L327.751 -107.431L317.17 -97.5662L318.181 -96.481L328.757 -106.352Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.714 -106.396L214.751 -107.43L204.612 -97.9776L205.581 -96.9388L215.714 -106.396Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.319 -106.385L340.345 -107.43L330.092 -97.8724L331.072 -96.8215L341.319 -106.385Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.154 -106.434L202.228 -107.429L192.472 -98.3338L193.404 -97.3336L203.154 -106.434Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.881 -106.422L352.942 -107.429L343.062 -98.2181L344.006 -97.2052L353.881 -106.422Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.595 -106.474L189.707 -107.427L180.365 -98.7174L181.258 -97.7594L190.595 -106.474Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.443 -106.461L365.542 -107.427L356.066 -98.5939L356.972 -97.6226L366.443 -106.461Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.004 -106.504L378.144 -107.426L369.098 -98.992L369.963 -98.0647L379.004 -106.504Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.037 -106.518L177.19 -107.425L168.283 -99.1222L169.135 -98.209L178.037 -106.518Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.566 -106.548L390.749 -107.425L382.151 -99.4085L382.973 -98.527L391.566 -106.548Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.478 -106.562L164.674 -107.424L156.221 -99.5435L157.029 -98.6765L165.478 -106.562Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.918 -106.608L152.16 -107.423L144.175 -99.9772L144.937 -99.1587L152.918 -106.608Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.129 -106.593L403.356 -107.423L395.221 -99.8391L395.999 -99.0052L404.129 -106.593Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.691 -106.641L415.963 -107.422L408.304 -100.281L409.036 -99.4953L416.691 -106.641Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.36 -106.656L139.647 -107.421L132.139 -100.422L132.857 -99.652L140.36 -106.656Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.8 -106.703L127.133 -107.42L120.113 -100.875L120.784 -100.154L127.8 -106.703Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.253 -106.688L428.571 -107.42L421.397 -100.73L422.082 -99.995L429.253 -106.688Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.816 -106.736L441.18 -107.418L434.498 -101.188L435.137 -100.503L441.816 -106.736Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.242 -106.752L114.622 -107.417L108.096 -101.334L108.72 -100.664L115.242 -106.752Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.378 -106.786L453.79 -107.416L447.606 -101.651L448.196 -101.017L454.378 -106.786Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.683 -106.801L102.11 -107.416L96.0853 -101.799L96.661 -101.181L102.683 -106.801Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.939 -106.835L466.4 -107.415L460.719 -102.119L461.263 -101.536L466.939 -106.835Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1243 -106.851L89.6 -107.414L84.0795 -102.267L84.607 -101.702L90.1243 -106.851Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.502 -106.885L479.01 -107.413L473.839 -102.591L474.333 -102.06L479.502 -106.885Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5657 -106.901L77.0887 -107.412L72.078 -102.741L72.5573 -102.227L77.5657 -106.901Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.065 -106.936L491.622 -107.411L486.961 -103.066L487.406 -102.588L492.065 -106.936Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0074 -106.952L64.5796 -107.41L60.0809 -103.217L60.5115 -102.756L65.0074 -106.952Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.627 -106.986L504.233 -107.41L500.087 -103.544L500.483 -103.119L504.627 -106.986Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4479 -107.003L52.0695 -107.409L48.0866 -103.696L48.4671 -103.287L52.4479 -107.003Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.189 -107.037L516.844 -107.408L513.216 -104.024L513.562 -103.653L517.189 -107.037Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8896 -107.054L39.5603 -107.407L36.0956 -104.177L36.4267 -103.821L39.8896 -107.054Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.752 -107.089L529.456 -107.406L526.347 -104.507L526.644 -104.189L529.752 -107.089Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3307 -107.105L27.0508 -107.405L24.1064 -104.66L24.3875 -104.359L27.3307 -107.105Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7715 -107.156L14.5413 -107.404L12.119 -105.145L12.3504 -104.897L14.7715 -107.156Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.314 -107.14L542.068 -107.404L539.481 -104.992L539.728 -104.727L542.314 -107.14Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.876 -107.191L554.68 -107.402L552.616 -105.478L552.814 -105.267L554.876 -107.191Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21346 -107.208L2.033 -107.401L0.134368 -105.631L0.315735 -105.437L2.21346 -107.208Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.439 -107.244L567.293 -107.4L565.753 -105.965L565.9 -105.807L567.439 -107.244Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 -107.273L579.882 -107.399L578.641 -106.242L578.759 -106.116L580 -107.273Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.514 -93.7783L277.5 -94.8674L266.818 -84.9089L267.838 -83.814L278.514 -93.7783Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.394 -93.7964L252.396 -94.8668L241.899 -85.0804L242.902 -84.0039L253.394 -93.7964Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.954 -93.7834L264.944 -94.8668L254.316 -84.9586L255.331 -83.8689L265.954 -93.7834Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.075 -93.781L290.063 -94.8668L279.409 -84.9348L280.427 -83.8423L291.075 -93.781Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.636 -93.7915L302.634 -94.8668L292.087 -85.034L293.095 -83.9527L303.636 -93.7915Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.834 -93.8159L239.856 -94.8662L229.559 -85.2666L230.543 -84.2112L240.834 -93.8159Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.197 -93.8093L315.213 -94.8662L304.845 -85.2012L305.836 -84.1386L316.197 -93.8093Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.758 -93.8331L327.796 -94.8656L317.673 -85.427L318.64 -84.3893L328.758 -93.8331Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.275 -93.8419L227.321 -94.8647L217.286 -85.5086L218.245 -84.4803L228.275 -93.8419Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.715 -93.8723L214.791 -94.8641L205.066 -85.7979L205.996 -84.8007L215.715 -93.8723Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.32 -93.8623L340.386 -94.8641L330.559 -85.7018L331.498 -84.6946L341.32 -93.8623Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.156 -93.9066L202.264 -94.8629L192.891 -86.1237L193.787 -85.1624L203.156 -93.9066Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.883 -93.8955L352.98 -94.8629L343.492 -86.0174L344.398 -85.0445L353.883 -93.8955Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.596 -93.9449L189.742 -94.8617L180.752 -86.4796L181.61 -85.5578L190.596 -93.9449Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.444 -93.9323L365.578 -94.8614L356.464 -86.3645L357.334 -85.4303L366.444 -93.9323Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.037 -93.9847L177.222 -94.8602L168.64 -86.8591L169.461 -85.9797L178.037 -93.9847Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.005 -93.972L378.177 -94.8602L369.464 -86.7367L370.297 -85.8441L379.005 -93.972Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.567 -94.0136L390.78 -94.8587L382.49 -87.1303L383.282 -86.2805L391.567 -94.0136Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.479 -94.0269L164.703 -94.8581L156.552 -87.2578L157.33 -86.4227L165.479 -94.0269Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.13 -94.0573L403.384 -94.8575L395.535 -87.5402L396.285 -86.7355L404.13 -94.0573Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.92 -94.0712L152.187 -94.8569L144.481 -87.6725L145.218 -86.8823L152.92 -94.0712Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.36 -94.1164L139.671 -94.8557L132.425 -88.0992L133.118 -87.3567L140.36 -94.1164Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.692 -94.1022L415.989 -94.8557L408.596 -87.963L409.302 -87.205L416.692 -94.1022Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.254 -94.148L428.596 -94.8542L421.67 -88.3973L422.331 -87.6873L429.254 -94.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.802 -94.1625L127.157 -94.8535L120.381 -88.5362L121.029 -87.8412L127.802 -94.1625Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.816 -94.1951L441.203 -94.853L434.754 -88.8397L435.371 -88.1785L441.816 -94.1951Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.243 -94.2101L114.644 -94.8524L108.347 -88.9813L108.949 -88.3358L115.243 -94.2101Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.378 -94.2424L453.811 -94.8509L447.846 -89.2899L448.417 -88.6785L454.378 -94.2424Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.684 -94.2578L102.131 -94.8503L96.3212 -89.4337L96.8764 -88.8379L102.684 -94.2578Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1249 -94.3069L89.6199 -94.849L84.3021 -89.8912L84.8104 -89.3463L90.1249 -94.3069Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.941 -94.2915L466.421 -94.849L460.947 -89.7462L461.47 -89.1851L466.941 -94.2915Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.503 -94.3403L479.031 -94.8475L474.053 -90.2073L474.529 -89.6974L479.503 -94.3403Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5666 -94.3557L77.1083 -94.8469L72.2891 -90.3541L72.7498 -89.8601L77.5666 -94.3557Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.065 -94.3894L491.639 -94.8457L487.164 -90.6736L487.592 -90.2145L492.065 -94.3894Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.008 -94.4051L64.5973 -94.8448L60.2813 -90.8209L60.6937 -90.3785L65.008 -94.4051Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.627 -94.4395L504.25 -94.8442L500.28 -91.1431L500.66 -90.7356L504.627 -94.4395Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4491 -94.4548L52.0866 -94.8436L48.277 -91.292L48.6413 -90.9011L52.4491 -94.4548Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.19 -94.4892L516.861 -94.8424L513.4 -91.615L513.73 -91.2606L517.19 -94.4892Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8896 -94.5052L39.5759 -94.8418L36.2764 -91.7654L36.5915 -91.4276L39.8896 -94.5052Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.752 -94.5401L529.472 -94.8403L526.522 -92.0912L526.804 -91.7886L529.752 -94.5401Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3313 -94.5558L27.0661 -94.8397L24.2794 -92.2413L24.5457 -91.9559L27.3313 -94.5558Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.314 -94.5905L542.083 -94.8391L539.648 -92.5689L539.881 -92.3196L542.314 -94.5905Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7727 -94.607L14.5566 -94.8385L12.285 -92.7202L12.502 -92.4875L14.7727 -94.607Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.876 -94.6411L554.694 -94.837L552.776 -93.0486L552.959 -92.8524L554.876 -94.6411Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21346 -94.658L2.04685 -94.8364L0.292537 -93.2011L0.460045 -93.0212L2.21346 -94.658Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.439 -94.6929L567.306 -94.8352L565.907 -93.5309L566.04 -93.3874L567.439 -94.6929Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 -94.708L579.882 -94.8343L578.641 -93.6779L578.759 -93.5507L580 -94.708Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.956 -81.2711L264.997 -82.3008L254.902 -72.8899L255.867 -71.855L265.956 -81.2711Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.517 -81.2665L277.553 -82.3008L267.412 -72.8468L268.382 -71.8074L278.517 -81.2665Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.077 -81.2693L290.116 -82.3008L279.999 -72.8694L280.966 -71.8327L291.077 -81.2693Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.396 -81.2825L252.447 -82.3002L242.468 -72.9966L243.421 -71.9734L253.396 -81.2825Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.638 -81.2786L302.685 -82.3002L292.663 -72.9562L293.621 -71.9285L303.638 -81.2786Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.836 -81.3003L239.905 -82.2996L230.103 -73.1617L231.039 -72.1567L240.836 -81.3003Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.2 -81.2936L315.261 -82.2996L305.398 -73.1036L306.34 -72.0925L316.2 -81.2936Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.276 -81.3235L227.367 -82.299L217.798 -73.3787L218.713 -72.3975L228.276 -81.3235Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.76 -81.3154L327.843 -82.2987L318.196 -73.3046L319.118 -72.3161L328.76 -81.3154Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.322 -81.3419L340.431 -82.2981L331.051 -73.5532L331.947 -72.5919L341.322 -81.3419Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.717 -81.3506L214.834 -82.2975L205.548 -73.6397L206.436 -72.6883L215.717 -81.3506Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.157 -81.3823L202.305 -82.2969L193.34 -73.9396L194.197 -73.0204L203.157 -81.3823Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.883 -81.3723L353.022 -82.2969L343.951 -73.841L344.818 -72.9113L353.883 -81.3723Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.598 -81.4175L189.78 -82.2957L181.171 -74.2696L181.994 -73.3866L190.598 -81.4175Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.445 -81.4061L365.616 -82.2954L356.891 -74.1623L357.725 -73.2675L366.445 -81.4061Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.039 -81.4552L177.257 -82.2942L169.031 -74.6252L169.818 -73.782L178.039 -81.4552Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.007 -81.4431L378.213 -82.2942L369.864 -74.5101L370.662 -73.6545L379.007 -81.4431Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.479 -81.4956L164.736 -82.293L156.916 -75.0022L157.664 -74.2006L165.479 -81.4956Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.569 -81.4829L390.814 -82.293L382.863 -74.8811L383.623 -74.0665L391.569 -81.4829Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.131 -81.5239L403.415 -82.2915L395.884 -75.2708L396.603 -74.4983L404.131 -81.5239Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.921 -81.5372L152.217 -82.2909L144.822 -75.3961L145.529 -74.6385L152.921 -81.5372Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.693 -81.5667L416.018 -82.2903L408.923 -75.6746L409.601 -74.9474L416.693 -81.5667Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.362 -81.5806L139.701 -82.2897L132.745 -75.8048L133.41 -75.092L140.362 -81.5806Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.255 -81.611L428.623 -82.2888L421.976 -76.092L422.612 -75.4103L429.255 -81.611Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.803 -81.6248L127.185 -82.2882L120.682 -76.2255L121.304 -75.5589L127.803 -81.6248Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.817 -81.6562L441.229 -82.287L435.042 -76.519L435.633 -75.8849L441.817 -81.6562Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.244 -81.6707L114.669 -82.2864L108.63 -76.6559L109.208 -76.0371L115.244 -81.6707Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.379 -81.7023L453.836 -82.2858L448.119 -76.9557L448.665 -76.3692L454.379 -81.7023Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.685 -81.7177L102.156 -82.2849L96.589 -77.0952L97.1204 -76.5244L102.685 -81.7177Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.942 -81.7493L466.443 -82.2837L461.204 -77.3993L461.705 -76.8623L466.942 -81.7493Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1261 -81.7644L89.6422 -82.2831L84.5552 -77.541L85.0412 -77.019L90.1261 -81.7644Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.503 -81.7975L479.052 -82.2824L474.297 -77.849L474.751 -77.3617L479.503 -81.7975Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5672 -81.8129L77.1303 -82.2816L72.5293 -77.9924L72.9688 -77.5211L77.5672 -81.8129Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.066 -81.8458L491.661 -82.2803L487.396 -78.3047L487.803 -77.8677L492.066 -81.8458Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0083 -81.8611L64.6175 -82.2798L60.509 -78.4493L60.9016 -78.0283L65.0083 -81.8611Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.628 -81.894L504.27 -82.2791L500.501 -78.7649L500.861 -78.3782L504.628 -81.894Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4491 -81.91L52.1059 -82.2785L48.4939 -78.911L48.8392 -78.5409L52.4491 -81.91Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.19 -81.9437L516.88 -82.277L513.61 -79.229L513.923 -78.8938L517.19 -81.9437Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8908 -81.9597L39.5952 -82.2764L36.4843 -79.376L36.7813 -79.0572L39.8908 -81.9597Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.753 -81.9934L529.49 -82.2752L526.724 -79.6967L526.988 -79.4131L529.753 -81.9934Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3319 -82.0091L27.0839 -82.2749L24.4776 -79.8447L24.7267 -79.5776L27.3319 -82.0091Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.315 -82.0429L542.1 -82.2737L539.841 -80.1668L540.057 -79.9354L542.315 -82.0429Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7733 -82.0588L14.5735 -82.2731L12.4748 -80.3163L12.6752 -80.1014L14.7733 -82.0588Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.877 -82.0932L554.711 -82.2719L552.961 -80.6403L553.128 -80.4613L554.877 -82.0932Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21406 -82.1092L2.06312 -82.271L0.474506 -80.7904L0.626348 -80.6279L2.21406 -82.1092Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 -82.1435L567.321 -82.2698L566.08 -81.1131L566.199 -80.9863L567.44 -82.1435Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 -82.1435L579.882 -82.2698L578.641 -81.1131L578.759 -80.9863L580 -82.1435Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.958 -68.7593L265.05 -69.7343L255.492 -60.8227L256.405 -59.8432L265.958 -68.7593Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.518 -68.7554L277.606 -69.7343L268.007 -60.785L268.924 -59.8011L278.518 -68.7554Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.079 -68.7575L290.169 -69.7343L280.591 -60.8049L281.506 -59.8228L291.079 -68.7575Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.398 -68.7696L252.499 -69.7336L243.043 -60.9179L243.947 -59.9484L253.398 -68.7696Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.64 -68.7654L302.737 -69.7336L293.242 -60.8815L294.15 -59.9086L303.64 -68.7654Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.201 -68.7801L315.312 -69.7336L305.959 -61.0132L306.852 -60.0542L316.201 -68.7801Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.838 -68.7855L239.954 -69.733L230.657 -61.0653L231.545 -60.1127L240.838 -68.7855Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.762 -68.7991L327.892 -69.7328L318.734 -61.1943L319.609 -60.2558L328.762 -68.7991Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.278 -68.8057L227.414 -69.7321L218.329 -61.2612L219.197 -60.33L228.278 -68.8057Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.718 -68.8316L214.88 -69.7315L206.05 -61.4999L206.894 -60.5946L215.718 -68.8316Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.323 -68.8229L340.476 -69.7315L331.561 -61.4203L332.413 -60.5066L341.323 -68.8229Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.885 -68.8506L353.065 -69.7309L344.434 -61.6843L345.259 -60.7995L353.885 -68.8506Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.159 -68.8606L202.348 -69.7303L193.815 -61.775L194.63 -60.9001L203.159 -68.8606Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.599 -68.8931L189.82 -69.7297L181.617 -62.0818L182.401 -61.2413L190.599 -68.8931Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.447 -68.8826L365.657 -69.7294L357.347 -61.9818L358.14 -61.1301L366.447 -68.8826Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.009 -68.9169L378.252 -69.7285L370.292 -62.3073L371.053 -61.4915L379.009 -68.9169Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.04 -68.9281L177.294 -69.7282L169.451 -62.4152L170.2 -61.6117L178.04 -68.9281Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.48 -68.9661L164.771 -69.727L157.311 -62.7717L158.024 -62.0065L165.48 -68.9661Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.571 -68.954L390.849 -69.727L383.266 -62.6566L383.99 -61.8793L391.571 -68.954Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.922 -69.0061L152.251 -69.7258L145.194 -63.1457L145.868 -62.4224L152.922 -69.0061Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.132 -68.9929L403.448 -69.7258L396.262 -63.0254L396.949 -62.2889L404.132 -68.9929Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.362 -69.0471L139.731 -69.7243L133.095 -63.5366L133.729 -62.856L140.362 -69.0471Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.694 -69.0339L416.05 -69.7243L409.279 -63.4118L409.926 -62.7174L416.694 -69.0339Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.256 -69.0764L428.653 -69.7231L422.313 -63.8117L422.918 -63.1617L429.256 -69.0764Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.804 -69.0902L127.214 -69.7225L121.012 -63.9407L121.605 -63.3045L127.804 -69.0902Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.818 -69.1201L441.257 -69.7219L435.361 -64.2231L435.924 -63.6188L441.818 -69.1201Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.244 -69.1345L114.698 -69.721L108.942 -64.3554L109.492 -63.7656L115.244 -69.1345Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.686 -69.1794L102.182 -69.7198L96.8845 -64.7803L97.391 -64.2375L102.686 -69.1794Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.381 -69.1649L453.863 -69.7198L448.42 -64.6456L448.94 -64.0875L454.381 -69.1649Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.942 -69.2105L466.469 -69.7183L461.489 -65.076L461.965 -64.5657L466.942 -69.2105Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1267 -69.2249L89.6672 -69.7177L84.836 -65.2137L85.2976 -64.7182L90.1267 -69.2249Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5675 -69.2719L77.1535 -69.7165L72.7959 -65.654L73.2122 -65.2071L77.5675 -69.2719Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.505 -69.2569L479.076 -69.7165L474.568 -65.5139L474.999 -65.0518L479.505 -69.2569Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.067 -69.3045L491.684 -69.715L487.654 -65.9581L488.039 -65.5455L492.067 -69.3045Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0089 -69.319L64.6401 -69.7144L60.7633 -66.0997L61.1336 -65.7025L65.0089 -69.319Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4497 -69.3672L52.1273 -69.7132L48.7368 -66.5515L49.0606 -66.2043L52.4497 -69.3672Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.629 -69.3521L504.292 -69.7132L500.748 -66.4086L501.086 -66.0449L504.629 -69.3521Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.191 -69.4003L516.901 -69.7116L513.845 -66.8637L514.137 -66.5503L517.191 -69.4003Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8911 -69.4157L39.6154 -69.7113L36.7159 -67.0078L36.9928 -66.7109L39.8911 -69.4157Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3322 -69.4645L27.1035 -69.7098L24.6996 -67.4679L24.9292 -67.2214L27.3322 -69.4645Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.754 -69.4485L529.51 -69.7098L526.949 -67.3224L527.194 -67.0599L529.754 -69.4485Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.315 -69.4983L542.12 -69.7086L540.057 -67.7856L540.254 -67.574L542.315 -69.4983Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7736 -69.5133L14.5925 -69.7077L12.6878 -67.9323L12.8698 -67.7365L14.7736 -69.5133Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.878 -69.5471L554.729 -69.7065L553.169 -68.2509L553.318 -68.0909L554.878 -69.5471Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21466 -69.5631L2.0812 -69.7059L0.679372 -68.3992L0.813138 -68.2551L2.21466 -69.5631Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 -69.5787L567.321 -69.7053L566.08 -68.5486L566.199 -68.4218L567.44 -69.5787Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 -69.5787L579.882 -69.7053L578.641 -68.5486L578.759 -68.4218L580 -69.5787Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.96 -56.2479L265.102 -57.1677L256.081 -48.7573L256.943 -47.8321L265.96 -56.2479Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.52 -56.2437L277.659 -57.1677L268.601 -48.7229L269.467 -47.7944L278.52 -56.2437Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.081 -56.2458L290.222 -57.1677L281.183 -48.7407L282.047 -47.8143L291.081 -56.2458Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.641 -56.2533L302.789 -57.1677L293.825 -48.8103L294.681 -47.8912L303.641 -56.2533Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.84 -56.2711L240.005 -57.1671L231.219 -48.9755L232.059 -48.075L240.84 -56.2711Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.4 -56.2572L252.551 -57.1671L243.621 -48.842L244.475 -47.9267L253.4 -56.2572Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.203 -56.2657L315.363 -57.1671L306.527 -48.9285L307.371 -48.0226L316.203 -56.2657Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.279 -56.2901L227.463 -57.1665L218.869 -49.1542L219.69 -48.2733L228.279 -56.2901Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.764 -56.2834L327.941 -57.1665L319.282 -49.0933L320.109 -48.2058L328.764 -56.2834Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.325 -56.3055L340.523 -57.1656L332.086 -49.2995L332.893 -48.4345L341.325 -56.3055Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.721 -56.3133L214.926 -57.1649L206.567 -49.373L207.366 -48.5159L215.721 -56.3133Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.886 -56.3314L353.109 -57.1649L344.934 -49.543L345.716 -48.7052L353.886 -56.3314Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.161 -56.3404L202.392 -57.1644L194.307 -49.6267L195.08 -48.7983L203.161 -56.3404Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.448 -56.3603L365.699 -57.1638L357.822 -49.8193L358.575 -49.012L366.448 -56.3603Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.601 -56.3702L189.862 -57.1631L182.085 -49.9124L182.828 -49.1156L190.601 -56.3702Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.041 -56.4034L177.334 -57.1625L169.894 -50.2256L170.605 -49.4631L178.041 -56.4034Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.01 -56.3925L378.292 -57.1622L370.742 -50.124L371.464 -49.3498L379.01 -56.3925Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.482 -56.439L164.809 -57.161L157.731 -50.5613L158.407 -49.8359L165.482 -56.439Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.572 -56.4275L390.888 -57.161L383.692 -50.4528L384.38 -49.7157L391.572 -56.4275Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.923 -56.4766L152.286 -57.1598L145.591 -50.9172L146.231 -50.2307L152.923 -56.4766Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.134 -56.4649L403.485 -57.1598L396.667 -50.8027L397.318 -50.1038L404.134 -56.4649Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.364 -56.5164L139.765 -57.1583L133.471 -51.29L134.073 -50.6448L140.364 -56.5164Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.695 -56.5038L416.085 -57.1583L409.662 -51.1704L410.276 -50.5125L416.695 -56.5038Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.805 -56.5574L127.246 -57.1571L121.369 -51.6776L121.931 -51.0751L127.805 -56.5574Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.257 -56.5447L428.686 -57.1571L422.675 -51.554L423.25 -50.9377L429.257 -56.5447Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.819 -56.5866L441.288 -57.1559L435.705 -51.95L436.238 -51.3774L441.819 -56.5866Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.246 -56.6002L114.728 -57.155L109.282 -52.0778L109.802 -51.5191L115.246 -56.6002Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.381 -56.6294L453.892 -57.1544L448.747 -52.3575L449.238 -51.8304L454.381 -56.6294Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.686 -56.6433L102.21 -57.1538L97.206 -52.4883L97.6847 -51.975L102.686 -56.6433Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1273 -56.6882L89.6949 -57.1526L85.1427 -52.9084L85.5777 -52.4416L90.1273 -56.6882Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.944 -56.6737L466.497 -57.1523L461.801 -52.7746L462.25 -52.2933L466.944 -56.6737Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.506 -56.7192L479.103 -57.1511L474.865 -53.2004L475.27 -52.7661L479.506 -56.7192Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.569 -56.7334L77.1797 -57.1505L73.089 -53.336L73.4795 -52.9168L77.569 -56.7334Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.068 -56.765L491.709 -57.1499L487.938 -53.6338L488.298 -53.2468L492.068 -56.765Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0101 -56.7795L64.6657 -57.149L61.0429 -53.7712L61.3894 -53.4002L65.0101 -56.7795Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.63 -56.812L504.316 -57.1478L501.017 -54.0729L501.333 -53.735L504.63 -56.812Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4509 -56.8265L52.1517 -57.1472L49.004 -54.213L49.3047 -53.8903L52.4509 -56.8265Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.192 -56.8591L516.924 -57.1466L514.105 -54.518L514.374 -54.229L517.192 -56.8591Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.892 -56.8741L39.6383 -57.146L36.9717 -54.6594L37.2263 -54.3863L39.892 -56.8741Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.754 -56.9064L529.532 -57.1445L527.197 -54.9677L527.421 -54.729L529.754 -56.9064Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3331 -56.9218L27.1258 -57.1439L24.9449 -55.1111L25.1534 -54.8875L27.3331 -56.9218Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.316 -56.9546L542.14 -57.1432L540.295 -55.4218L540.471 -55.2328L542.316 -56.9546Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7745 -56.97L14.6139 -57.1426L12.9234 -55.5668L13.0849 -55.3935L14.7745 -56.97Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 -57.0031L554.75 -57.1411L553.398 -55.8802L553.526 -55.7419L554.879 -57.0031Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 -57.0143L2.09717 -57.1405L0.85622 -55.9839L0.974621 -55.857L2.21497 -57.0143Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 -57.0143L567.321 -57.1405L566.08 -55.9839L566.199 -55.857L567.44 -57.0143Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 -57.0143L579.882 -57.1405L578.641 -55.9839L578.759 -55.857L580 -57.0143Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.401 -43.744L252.603 -44.6011L244.203 -36.7693L245.006 -35.9083L253.401 -43.744Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.962 -43.7361L265.155 -44.6011L256.672 -36.6922L257.482 -35.8224L265.962 -43.7361Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.522 -43.7328L277.712 -44.6011L269.196 -36.6608L270.009 -35.7881L278.522 -43.7328Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.083 -43.7349L290.275 -44.6011L281.775 -36.6768L282.587 -35.8059L291.083 -43.7349Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.644 -43.7413L302.842 -44.6011L294.41 -36.7395L295.216 -35.8752L303.644 -43.7413Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.841 -43.7572L240.055 -44.6005L231.786 -36.8911L232.576 -36.0433L240.841 -43.7572Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.204 -43.7527L315.414 -44.6005L307.098 -36.848L307.893 -35.9957L316.204 -43.7527Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.282 -43.7744L227.512 -44.5999L219.419 -37.0544L220.192 -36.2245L228.282 -43.7744Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.766 -43.7684L327.99 -44.5999L319.837 -36.999L320.616 -36.163L328.766 -43.7684Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.722 -43.7961L214.973 -44.599L207.097 -37.2561L207.849 -36.4487L215.722 -43.7961Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.327 -43.7889L340.571 -44.599L332.622 -37.1886L333.382 -36.3733L341.327 -43.7889Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.162 -43.8208L202.437 -44.5984L194.815 -37.492L195.544 -36.7106L203.162 -43.8208Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.888 -43.813L353.156 -44.5984L345.45 -37.4143L346.186 -36.6241L353.888 -43.813Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.45 -43.8398L365.743 -44.5978L358.314 -37.6713L359.024 -36.9095L366.45 -43.8398Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.603 -43.8492L189.906 -44.5972L182.571 -37.7587L183.271 -37.0068L190.603 -43.8492Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.043 -43.8802L177.376 -44.5966L170.357 -38.0523L171.027 -37.3329L178.043 -43.8802Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.011 -43.8703L378.334 -44.5963L371.212 -37.957L371.893 -37.2268L379.011 -43.8703Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.484 -43.914L164.849 -44.5951L158.171 -38.3696L158.81 -37.6852L165.484 -43.914Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.573 -43.9034L390.928 -44.5951L384.14 -38.2672L384.788 -37.5716L391.573 -43.9034Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.924 -43.9498L152.324 -44.5939L146.011 -38.7075L146.614 -38.0601L152.924 -43.9498Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.135 -43.9387L403.524 -44.5939L397.093 -38.5987L397.708 -37.9393L404.135 -43.9387Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.365 -43.9875L139.801 -44.5927L133.87 -39.0634L134.437 -38.4558L140.365 -43.9875Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.697 -43.9754L416.121 -44.5923L410.068 -38.9489L410.646 -38.3286L416.697 -43.9754Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.805 -44.0273L127.28 -44.5911L121.749 -39.4344L122.277 -38.8678L127.805 -44.0273Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.259 -44.0146L428.72 -44.5911L423.062 -39.3159L423.602 -38.7361L429.259 -44.0146Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.247 -44.0683L114.761 -44.5899L109.644 -39.8192L110.133 -39.2948L115.247 -44.0683Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.821 -44.055L441.322 -44.5899L436.073 -39.6969L436.574 -39.1586L441.821 -44.055Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.383 -44.0966L453.924 -44.5884L449.099 -40.0899L449.559 -39.595L454.383 -44.0966Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.688 -44.1098L102.242 -44.5878L97.5528 -40.2161L98.0011 -39.7354L102.688 -44.1098Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.944 -44.1394L466.527 -44.5872L462.136 -40.4937L462.556 -40.0434L466.944 -44.1394Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1285 -44.1535L89.7245 -44.5866L85.4732 -40.6227L85.879 -40.1869L90.1285 -44.1535Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.506 -44.1831L479.131 -44.586L475.186 -40.9066L475.562 -40.5024L479.506 -44.1831Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5693 -44.1969L77.2077 -44.5851L73.4039 -41.0386L73.7675 -40.6492L77.5693 -44.1969Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.069 -44.2283L491.737 -44.5839L488.244 -41.3276L488.578 -40.9699L492.069 -44.2283Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0107 -44.2419L64.6922 -44.5833L61.3445 -41.4626L61.6644 -41.1193L65.0107 -44.2419Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.63 -44.2732L504.342 -44.5827L501.311 -41.7561L501.601 -41.4454L504.63 -44.2732Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4521 -44.2877L52.1779 -44.5821L49.2938 -41.8933L49.5695 -41.5976L52.4521 -44.2877Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8932 -44.3341L39.6636 -44.5806L37.2498 -42.3297L37.4806 -42.0822L39.8932 -44.3341Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.193 -44.3193L516.949 -44.5806L514.386 -42.1913L514.631 -41.9288L517.193 -44.3193Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.755 -44.3663L529.557 -44.5794L527.468 -42.6316L527.668 -42.4176L529.755 -44.3663Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3343 -44.3811L27.1499 -44.5788L25.2121 -42.7721L25.3974 -42.5738L27.3343 -44.3811Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7748 -44.4284L14.6365 -44.5773L13.1798 -43.219L13.319 -43.0695L14.7748 -44.4284Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.318 -44.4133L542.164 -44.5773L540.555 -43.0777L540.709 -42.9122L542.318 -44.4133Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 -44.4498L2.09717 -44.5761L0.85622 -43.4194L0.974621 -43.2925L2.21497 -44.4498Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 -44.4498L554.76 -44.5761L553.52 -43.4194L553.638 -43.2925L554.879 -44.4498Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 -44.4498L567.321 -44.5761L566.08 -43.4194L566.199 -43.2925L567.44 -44.4498Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 -44.4498L579.882 -44.5761L578.641 -43.4194L578.759 -43.2925L580 -44.4498Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.403 -31.2322L252.655 -32.0345L244.786 -24.6979L245.538 -23.8911L253.403 -31.2322Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.964 -31.2244L265.208 -32.0345L257.263 -24.6274L258.022 -23.8128L265.964 -31.2244Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.524 -31.222L277.766 -32.0345L269.79 -24.5991L270.552 -23.7817L278.524 -31.222Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.085 -31.2232L290.328 -32.0345L282.368 -24.6135L283.129 -23.7974L291.085 -31.2232Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.645 -31.2289L302.894 -32.0345L294.996 -24.6711L295.751 -23.8616L303.645 -31.2289Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.206 -31.2395L315.465 -32.0345L307.674 -24.7702L308.419 -23.9713L316.206 -31.2395Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.843 -31.2443L240.107 -32.0339L232.358 -24.81L233.099 -24.0159L240.843 -31.2443Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.767 -31.2542L328.04 -32.0339L320.399 -24.9089L321.129 -24.1253L328.767 -31.2542Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.283 -31.2603L227.562 -32.0333L219.975 -24.9607L220.701 -24.1832L228.283 -31.2603Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.328 -31.2732L340.62 -32.0333L333.168 -25.0849L333.879 -24.3206L341.328 -31.2732Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.89 -31.2952L353.203 -32.0327L345.976 -25.2946L346.667 -24.5533L353.89 -31.2952Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.723 -31.2799L215.021 -32.0324L207.636 -25.1479L208.342 -24.3905L215.723 -31.2799Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.164 -31.3031L202.484 -32.0318L195.335 -25.3673L196.019 -24.6346L203.164 -31.3031Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.604 -31.3296L189.95 -32.0312L183.071 -25.6168L183.728 -24.9119L190.604 -31.3296Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.451 -31.3208L365.789 -32.0312L358.82 -25.5345L359.487 -24.8206L366.451 -31.3208Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.013 -31.3495L378.378 -32.0306L371.699 -25.8033L372.337 -25.1189L379.013 -31.3495Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.045 -31.3585L177.419 -32.03L170.837 -25.8932L171.466 -25.2187L178.045 -31.3585Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.574 -31.3805L390.969 -32.0294L384.605 -26.0963L385.214 -25.4435L391.574 -31.3805Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.485 -31.3905L164.89 -32.0291L158.631 -26.1933L159.229 -25.5511L165.485 -31.3905Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.925 -31.4248L152.364 -32.0279L146.45 -26.514L147.015 -25.9076L152.925 -31.4248Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.137 -31.4137L403.563 -32.0279L397.538 -26.4109L398.114 -25.7934L404.137 -31.4137Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.366 -31.4604L139.839 -32.0267L134.291 -26.8539L134.821 -26.2846L140.366 -31.4604Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.698 -31.4492L416.159 -32.0267L410.493 -26.7448L411.035 -26.1635L416.698 -31.4492Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.259 -31.4863L428.757 -32.0261L423.469 -27.0953L423.974 -26.5531L429.259 -31.4863Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.807 -31.4981L127.316 -32.0252L122.151 -27.2095L122.645 -26.68L127.807 -31.4981Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.248 -31.5378L114.795 -32.024L110.028 -27.5793L110.483 -27.0908L115.248 -31.5378Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.822 -31.5255L441.357 -32.024L436.462 -27.4612L436.93 -26.9597L441.822 -31.5255Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.689 -31.5782L102.275 -32.0228L97.9194 -27.9624L98.3361 -27.516L102.689 -31.5782Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.384 -31.5656L453.957 -32.0228L449.47 -27.84L449.899 -27.3804L454.384 -31.5656Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.946 -31.6066L466.559 -32.0212L462.493 -28.2309L462.881 -27.8135L466.946 -31.6066Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.13 -31.6198L89.7558 -32.0206L85.8251 -28.3557L86.2005 -27.953L90.13 -31.6198Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.507 -31.649L479.162 -32.02L475.527 -28.6308L475.874 -28.2586L479.507 -31.649Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5711 -31.6629L77.2388 -32.0194L73.7416 -28.7592L74.076 -28.4009L77.5711 -31.6629Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.07 -31.6924L491.766 -32.0185L488.572 -29.0401L488.877 -28.7128L492.07 -31.6924Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0116 -31.7063L64.7215 -32.0179L61.6686 -29.1718L61.96 -28.8583L65.0116 -31.7063Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.453 -31.7509L52.2056 -32.0167L49.6044 -29.591L49.853 -29.3246L52.453 -31.7509Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.632 -31.737L504.371 -32.0167L501.626 -29.4581L501.889 -29.1766L504.632 -31.737Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.194 -31.782L516.976 -32.0152L514.689 -29.8827L514.907 -29.6479L517.194 -31.782Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8938 -31.7964L39.6901 -32.0146L37.5481 -30.0177L37.7526 -29.798L39.8938 -31.7964Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3352 -31.8422L27.1758 -32.0134L25.4995 -30.4502L25.6595 -30.2787L27.3352 -31.8422Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.756 -31.8275L529.582 -32.0131L527.758 -30.3131L527.933 -30.1259L529.756 -31.8275Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.318 -31.8739L542.189 -32.0119L540.835 -30.7498L540.964 -30.6108L542.318 -31.8739Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 -31.885L2.09717 -32.0113L0.85622 -30.8549L0.974621 -30.7278L2.21497 -31.885Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7757 -31.885L14.6576 -32.0113L13.4166 -30.8549L13.5353 -30.7278L14.7757 -31.885Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 -31.885L554.76 -32.0113L553.52 -30.8549L553.638 -30.7278L554.879 -31.885Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 -31.885L567.321 -32.0113L566.08 -30.8549L566.199 -30.7278L567.44 -31.885Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 -31.885L579.882 -32.0113L578.641 -30.8549L578.759 -30.7278L580 -31.885Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.965 -18.7136L265.262 -19.4685L257.855 -12.5635L258.563 -11.8037L265.965 -18.7136Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.526 -18.71L277.819 -19.4685L270.385 -12.5367L271.096 -11.7751L278.526 -18.71Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.086 -18.7121L290.381 -19.4685L282.961 -12.5508L283.67 -11.7896L291.086 -18.7121Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.845 -18.7314L240.159 -19.4679L232.934 -12.732L233.624 -11.9915L240.845 -18.7314Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.405 -18.7199L252.708 -19.4679L245.372 -12.628L246.072 -11.8764L253.405 -18.7199Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.647 -18.7172L302.947 -19.4679L295.584 -12.6036L296.288 -11.8483L303.647 -18.7172Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.208 -18.7274L315.517 -19.4679L308.253 -12.6949L308.947 -11.9505L316.208 -18.7274Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.285 -18.7458L227.613 -19.4673L220.538 -12.8715L221.214 -12.1461L228.285 -18.7458Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.769 -18.7404L328.092 -19.4673L320.966 -12.8239L321.647 -12.0934L328.769 -18.7404Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.725 -18.7642L215.07 -19.4667L208.183 -13.0454L208.841 -12.3393L215.725 -18.7642Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.33 -18.7582L340.669 -19.4667L333.72 -12.9872L334.384 -12.2745L341.33 -18.7582Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.165 -18.7862L202.532 -19.4661L195.865 -13.2512L196.503 -12.5674L203.165 -18.7862Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.891 -18.779L353.251 -19.4661L346.511 -13.1831L347.155 -12.4921L353.891 -18.779Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.453 -18.8028L365.835 -19.4652L359.338 -13.4079L359.96 -12.7419L366.453 -18.8028Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.606 -18.8106L189.996 -19.4646L183.582 -13.4851L184.195 -12.8278L190.606 -18.8106Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.046 -18.8383L177.463 -19.464L171.329 -13.7458L171.916 -13.1168L178.046 -18.8383Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.015 -18.8299L378.423 -19.464L372.198 -13.6605L372.793 -13.0225L379.015 -18.8299Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.576 -18.8588L391.013 -19.4631L385.086 -13.9374L385.652 -13.3299L391.576 -18.8588Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.487 -18.8688L164.933 -19.4625L159.105 -14.0294L159.662 -13.4323L165.487 -18.8688Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.927 -18.901L152.405 -19.4619L146.905 -14.335L147.431 -13.7708L152.927 -18.901Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.137 -18.8905L403.604 -19.4619L397.999 -14.2364L398.535 -13.6617L404.137 -18.8905Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.368 -18.9354L139.879 -19.4607L134.728 -14.6589L135.221 -14.1312L140.368 -18.9354Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.699 -18.9242L416.199 -19.4607L410.937 -14.5547L411.439 -14.0155L416.699 -18.9242Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.808 -18.9713L127.354 -19.4595L122.571 -14.9995L123.027 -14.5098L127.808 -18.9713Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.262 -18.9601L428.796 -19.4595L423.894 -14.8904L424.363 -14.388L429.262 -18.9601Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.823 -18.9969L441.393 -19.4586L436.871 -15.2415L437.302 -14.778L441.823 -18.9969Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.25 -19.0089L114.831 -19.458L110.431 -15.3554L110.851 -14.9043L115.25 -19.0089Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.69 -19.0487L102.31 -19.4568L98.3063 -15.7243L98.6889 -15.3144L102.69 -19.0487Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.385 -19.036L453.992 -19.4565L449.862 -15.6064L450.257 -15.1833L454.385 -19.036Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1309 -19.0891L89.7898 -19.4556L86.1969 -16.1052L86.54 -15.7369L90.1309 -19.0891Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.947 -19.0758L466.593 -19.4553L462.869 -15.9835L463.225 -15.6019L466.947 -19.0758Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5714 -19.1301L77.2698 -19.4541L74.098 -16.4967L74.4014 -16.1715L77.5714 -19.1301Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.509 -19.1168L479.194 -19.4541L475.888 -16.3716L476.204 -16.0332L479.509 -19.1168Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.071 -19.1593L491.797 -19.4529L488.919 -16.77L489.194 -16.4744L492.071 -19.1593Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0134 -19.1729L64.7528 -19.4519L62.0121 -16.8969L62.2736 -16.6157L65.0134 -19.1729Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.633 -19.2021L504.401 -19.4513L501.961 -17.1757L502.193 -16.9258L504.633 -19.2021Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4536 -19.216L52.2349 -19.4507L49.9343 -17.3062L50.1543 -17.0702L52.4536 -19.216Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.895 -19.2603L39.719 -19.4495L37.8665 -17.7221L38.0434 -17.5322L39.895 -19.2603Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.195 -19.2464L517.005 -19.4495L515.01 -17.5898L515.201 -17.3854L517.195 -19.2464Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.757 -19.2907L529.61 -19.448L528.068 -18.0105L528.216 -17.8526L529.757 -19.2907Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3355 -19.3052L27.2026 -19.4474L25.8056 -18.1446L25.9391 -18.0017L27.3355 -19.3052Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 -19.3205L2.09717 -19.4468L0.85622 -18.2901L0.974621 -18.1633L2.21497 -19.3205Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7757 -19.3205L14.6576 -19.4468L13.4166 -18.2901L13.5353 -18.1633L14.7757 -19.3205Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.318 -19.3205L542.2 -19.4468L540.959 -18.2901L541.078 -18.1633L542.318 -19.3205Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 -19.3205L554.76 -19.4468L553.52 -18.2901L553.638 -18.1633L554.879 -19.3205Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 -19.3205L567.321 -19.4468L566.08 -18.2901L566.199 -18.1633L567.44 -19.3205Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 -19.3205L579.882 -19.4468L578.641 -18.2901L578.759 -18.1633L580 -19.3205Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.527 -6.19913L277.872 -6.90224L270.979 -0.474884L271.638 0.231232L278.527 -6.19913Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.967 -6.20154L265.314 -6.90193L258.447 -0.499298L259.103 0.205017L265.967 -6.20154Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.088 -6.20033L290.435 -6.90193L283.555 -0.487534L284.212 0.217361L291.088 -6.20033Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.649 -6.20546L303 -6.90193L296.173 -0.536972L296.826 0.163422L303.649 -6.20546Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.847 -6.21841L240.21 -6.90132L233.511 -0.656006L234.151 0.0308228L240.847 -6.21841Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.407 -6.20818L252.761 -6.90132L245.958 -0.560165L246.608 0.137497L253.407 -6.20818Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.21 -6.2148L315.57 -6.90132L308.834 -0.621643L309.478 0.0687866L316.21 -6.2148Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.287 -6.23228L227.663 -6.90073L221.105 -0.786499L221.731 -0.113846L228.287 -6.23228Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.332 -6.24344L340.719 -6.90073L334.277 -0.894089L334.893 -0.23349L341.332 -6.24344Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.771 -6.22746L328.144 -6.90042L321.537 -0.741287L322.168 -0.0641174L328.771 -6.22746Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.727 -6.24947L215.12 -6.90012L208.736 -0.948334L209.346 -0.294357L215.727 -6.24947Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.167 -6.26996L202.58 -6.89952L196.404 -1.14151L196.994 -0.508026L203.167 -6.26996Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.893 -6.26332L353.3 -6.89952L347.055 -1.07732L347.652 -0.43721L353.893 -6.26332Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.607 -6.29286L190.043 -6.89862L184.104 -1.36151L184.671 -0.753357L190.607 -6.29286Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.454 -6.28563L365.883 -6.89862L359.866 -1.28979L360.441 -0.672577L366.454 -6.28563Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.047 -6.31938L177.509 -6.89801L171.835 -1.60774L172.377 -1.0264L178.047 -6.31938Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.016 -6.31094L378.468 -6.89801L372.708 -1.52757L373.258 -0.93718L379.016 -6.31094Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.577 -6.33836L391.056 -6.89742L385.578 -1.78946L386.102 -1.22801L391.577 -6.33836Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.488 -6.34801L164.976 -6.8968L159.592 -1.87747L160.107 -1.32535L165.488 -6.34801Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.139 -6.36819L403.647 -6.8959L398.476 -2.07396L398.969 -1.54355L404.139 -6.36819Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.929 -6.37814L152.446 -6.89529L147.376 -2.16768L147.86 -1.64812L152.929 -6.37814Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.369 -6.4113L139.919 -6.8947L135.181 -2.47719L135.634 -1.99199L140.369 -6.4113Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.701 -6.40074L416.24 -6.8947L411.395 -2.37744L411.858 -1.88078L416.701 -6.40074Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.81 -6.44626L127.393 -6.89349L123.007 -2.80388L123.426 -2.35423L127.81 -6.44626Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.263 -6.4351L428.835 -6.89349L424.336 -2.6987L424.766 -2.2379L429.263 -6.4351Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.824 -6.47067L441.431 -6.89259L437.295 -3.03654L437.69 -2.61221L441.824 -6.47067Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.251 -6.48212L114.868 -6.89198L110.851 -3.14594L111.235 -2.73396L115.251 -6.48212Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.386 -6.50774L454.029 -6.89139L450.271 -3.38794L450.631 -3.00308L454.386 -6.50774Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.691 -6.51979L102.345 -6.89078L98.7109 -3.50156L99.0579 -3.12936L102.691 -6.51979Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.948 -6.54692L466.628 -6.89018L463.263 -3.7523L463.585 -3.40723L466.948 -6.54692Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1324 -6.55867L89.8242 -6.88957L86.5855 -3.86983L86.8949 -3.53802L90.1324 -6.55867Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5729 -6.59904L77.3039 -6.88806L74.4731 -4.24896L74.7439 -3.95874L77.5729 -6.59904Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.51 -6.5864L479.228 -6.88806L476.268 -4.12781L476.55 -3.82433L479.51 -6.5864Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0137 -6.64064L64.785 -6.88657L62.3727 -4.63773L62.6035 -4.3903L65.0137 -6.64064Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.072 -6.62738L491.83 -6.88657L489.285 -4.51385L489.528 -4.25287L492.072 -6.62738Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.634 -6.66927L504.432 -6.88536L502.313 -4.90956L502.515 -4.69197L504.634 -6.66927Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4551 -6.68253L52.2665 -6.88475L50.2829 -5.03584L50.4724 -4.83211L52.4551 -6.68253Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.196 -6.71207L517.036 -6.88416L515.35 -5.31281L515.511 -5.13951L517.196 -6.71207Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8956 -6.72592L39.7486 -6.88354L38.2021 -5.44179L38.3497 -5.28326L39.8956 -6.72592Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.758 -6.75607L529.639 -6.88234L528.396 -5.72357L528.515 -5.59608L529.758 -6.75607Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 -6.75577L2.09717 -6.88203L0.85622 -5.72568L0.974621 -5.5985L2.21497 -6.75577Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7757 -6.75577L14.6576 -6.88203L13.4166 -5.72568L13.5353 -5.5985L14.7757 -6.75577Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3361 -6.75577L27.2183 -6.88203L25.9773 -5.72568L26.0957 -5.5985L27.3361 -6.75577Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.318 -6.75577L542.2 -6.88203L540.959 -5.72568L541.078 -5.5985L542.318 -6.75577Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 -6.75577L554.76 -6.88203L553.52 -5.72568L553.638 -5.5985L554.879 -6.75577Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 -6.75577L567.321 -6.88203L566.08 -5.72568L566.199 -5.5985L567.44 -6.75577Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 -6.75577L579.882 -6.88203L578.641 -5.72568L578.759 -5.5985L580 -6.75577Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.408 6.30417L252.813 5.66466L246.546 11.5079L247.145 12.1505L253.408 6.30417Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.969 6.30989L265.368 5.66466L259.04 11.5646L259.645 12.2135L265.969 6.30989Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.53 6.312L277.926 5.66466L271.573 11.5872L272.181 12.2379L278.53 6.312Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.09 6.3114L290.487 5.66466L284.147 11.5755L284.753 12.2252L291.09 6.3114Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.651 6.30597L303.053 5.66466L296.762 11.5296L297.364 12.1743L303.651 6.30597Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.849 6.29422L240.262 5.66525L234.092 11.4178L234.681 12.0507L240.849 6.29422Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.212 6.29753L315.623 5.66525L309.418 11.4495L310.01 12.0857L316.212 6.29753Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.772 6.28548L328.194 5.66525L322.11 11.3377L322.691 11.9621L328.772 6.28548Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.728 6.26498L215.17 5.66586L209.295 11.1442L209.857 11.7457L215.728 6.26498Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.289 6.28157L227.714 5.66586L221.675 11.2964L222.252 11.9151L228.289 6.28157Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.333 6.27101L340.769 5.66586L334.839 11.1948L335.406 11.8027L341.333 6.27101Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.168 6.246L202.629 5.66646L196.948 10.9622L197.491 11.5447L203.168 6.246Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.895 6.25233L353.349 5.66646L347.604 11.023L348.153 11.6116L353.895 6.25233Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.456 6.23123L365.93 5.66707L360.4 10.8226L360.929 11.3901L366.456 6.23123Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.609 6.224L190.09 5.66797L184.634 10.7545L185.155 11.3139L190.609 6.224Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.017 6.20743L378.515 5.66797L373.227 10.5978L373.733 11.1394L379.017 6.20743Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.049 6.19899L177.555 5.66858L172.349 10.5213L172.846 11.0547L178.049 6.19899Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.489 6.17186L165.021 5.66917L160.091 10.2651L160.562 10.7711L165.489 6.17186Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.579 6.18121L391.102 5.66917L386.083 10.3486L386.562 10.863L391.579 6.18121Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.14 6.15198L403.691 5.66978L398.962 10.0779L399.415 10.5629L404.14 6.15198Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.93 6.14262L152.49 5.67068L147.858 9.98874L148.301 10.4637L152.93 6.14262Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.702 6.12154L416.282 5.67128L411.866 9.78862L412.289 10.2407L416.702 6.12154Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.371 6.11159L139.96 5.67189L135.648 9.69249L136.059 10.1349L140.371 6.11159Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.811 6.07814L127.433 5.67249L123.457 9.37996L123.837 9.78711L127.811 6.07814Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.264 6.08929L428.875 5.67249L424.791 9.48032L425.182 9.89893L429.264 6.08929Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.252 6.04349L114.908 5.674L111.286 9.05116L111.632 9.42215L115.252 6.04349Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.826 6.05493L441.47 5.674L437.735 9.15634L438.092 9.53909L441.826 6.05493Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.387 6.01846L454.067 5.67461L450.697 8.8176L451.018 9.16267L454.387 6.01846Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.692 6.00702L102.383 5.6752L99.1305 8.7079L99.4415 9.04121L102.692 6.00702Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.949 5.9814L466.665 5.67581L463.673 8.4659L463.959 8.77271L466.949 5.9814Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1336 5.96935L89.8606 5.67641L86.991 8.35199L87.2652 8.64642L90.1336 5.96935Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.51 5.94252L479.264 5.67731L476.663 8.10214L476.912 8.36856L479.51 5.94252Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5741 5.93047L77.3388 5.67792L74.8644 7.98521L75.1009 8.23837L77.5741 5.93047Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0152 5.89008L64.8191 5.67912L62.7511 7.6076L62.9488 7.81915L65.0152 5.89008Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.073 5.90244L491.864 5.67912L489.667 7.72784L489.876 7.95267L492.073 5.90244Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.456 5.84909L52.299 5.68063L50.6477 7.22003L50.8056 7.3894L52.456 5.84909Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.635 5.86235L504.465 5.68063L502.682 7.3436L502.852 7.52623L504.635 5.86235Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.197 5.82077L517.068 5.68184L515.707 6.9503L515.837 7.08954L517.197 5.82077Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 5.80872L2.09717 5.68243L0.85622 6.8391L0.974621 6.96597L2.21497 5.80872Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7757 5.80872L14.6576 5.68243L13.4166 6.8391L13.5353 6.96597L14.7757 5.80872Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3361 5.80872L27.2183 5.68243L25.9773 6.8391L26.0957 6.96597L27.3361 5.80872Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8968 5.80872L39.7787 5.68243L38.5377 6.8391L38.6564 6.96597L39.8968 5.80872Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.758 5.80872L529.64 5.68243L528.399 6.8391L528.517 6.96597L529.758 5.80872Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.318 5.80872L542.2 5.68243L540.959 6.8391L541.078 6.96597L542.318 5.80872Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 5.80872L554.76 5.68243L553.52 6.8391L553.638 6.96597L554.879 5.80872Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 5.80872L567.321 5.68243L566.08 6.8391L566.199 6.96597L567.44 5.80872Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 5.80872L579.882 5.68243L578.641 6.8391L578.759 6.96597L580 5.80872Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.41 18.8156L252.865 18.2309L247.134 23.5749L247.682 24.1622L253.41 18.8156Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.971 18.821L265.421 18.2312L259.632 23.6279L260.185 24.2213L265.971 18.821Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.531 18.8237L277.979 18.2312L272.168 23.649L272.723 24.2442L278.531 18.8237Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.092 18.8225L290.541 18.2312L284.741 23.6378L285.296 24.2325L291.092 18.8225Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.653 18.8177L303.106 18.2312L297.353 23.595L297.903 24.1848L303.653 18.8177Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.213 18.8099L315.674 18.2312L310.001 23.5203L310.543 24.1023L316.213 18.8099Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.29 18.7945L227.766 18.2318L222.249 23.3759L222.775 23.9413L228.29 18.7945Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.851 18.8066L240.314 18.2318L234.674 23.4905L235.212 24.0691L240.851 18.8066Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.774 18.7987L328.246 18.2318L322.686 23.4157L323.217 23.985L328.774 18.7987Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.73 18.7794L215.22 18.2325L209.857 23.2325L210.37 23.7819L215.73 18.7794Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.336 18.7846L340.821 18.2325L335.406 23.2807L335.923 23.8362L341.336 18.7846Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.897 18.7674L353.398 18.233L348.159 23.1183L348.659 23.6556L353.897 18.7674Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.17 18.7617L202.677 18.2334L197.499 23.0613L197.994 23.5923L203.17 18.7617Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.458 18.7469L365.979 18.2337L360.943 22.9296L361.424 23.4462L366.458 18.7469Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.611 18.7403L190.138 18.2339L185.172 22.8648L185.646 23.3741L190.611 18.7403Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.05 18.7171L177.601 18.2346L172.872 22.6433L173.324 23.1279L178.05 18.7171Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.019 18.7246L378.562 18.2346L373.755 22.7159L374.215 23.2087L379.019 18.7246Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.58 18.6993L391.148 18.2352L386.595 22.4794L387.031 22.9462L391.58 18.6993Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.492 18.6908L165.067 18.2358L160.6 22.3998L161.027 22.8582L165.492 18.6908Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.931 18.6631L152.534 18.2364L148.351 22.1361L148.752 22.5647L152.931 18.6631Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.142 18.6721L403.735 18.2364L399.461 22.2214L399.869 22.6599L404.142 18.6721Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.703 18.6426L416.326 18.2373L412.349 21.9444L412.729 22.3516L416.703 18.6426Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.372 18.6333L140.003 18.2379L136.126 21.8531L136.496 22.2506L140.372 18.6333Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.265 18.6113L428.918 18.2385L425.259 21.6488L425.609 22.0243L429.265 18.6113Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.813 18.6013L127.474 18.2391L123.921 21.552L124.26 21.9164L127.813 18.6013Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.827 18.5784L441.512 18.2397L438.188 21.3372L438.506 21.6786L441.827 18.5784Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.253 18.5679L114.948 18.24L111.734 21.2362L112.042 21.5656L115.253 18.5679Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.694 18.5326L102.422 18.2409L99.565 20.9053L99.8379 21.1982L102.694 18.5326Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.389 18.5441L454.106 18.2412L451.135 21.0111L451.419 21.3161L454.389 18.5441Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.95 18.5076L466.703 18.2418L464.097 20.6711L464.346 20.9385L466.95 18.5076Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1348 18.4964L89.8983 18.2424L87.4113 20.5614L87.6484 20.8167L90.1348 18.4964Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.512 18.4705L479.3 18.243L477.074 20.3194L477.287 20.5476L479.512 18.4705Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5756 18.4588L77.3753 18.2439L75.2712 20.2058L75.4721 20.4213L77.5756 18.4588Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.074 18.4323L491.899 18.2445L490.064 19.9566L490.24 20.1443L492.074 18.4323Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0164 18.4196L64.8537 18.2451L63.1443 19.8394L63.3076 20.0145L65.0164 18.4196Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4575 18.3792L52.3334 18.2463L51.0286 19.4632L51.1533 19.5968L52.4575 18.3792Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.637 18.3925L504.5 18.2463L503.066 19.5829L503.203 19.7297L504.637 18.3925Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 18.3735L2.09717 18.2469L0.85622 19.4036L0.974621 19.5305L2.21497 18.3735Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7757 18.3735L14.6576 18.2469L13.4166 19.4036L13.5353 19.5305L14.7757 18.3735Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3361 18.3735L27.2183 18.2469L25.9773 19.4036L26.0957 19.5305L27.3361 18.3735Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8968 18.3735L39.7787 18.2469L38.5377 19.4036L38.6564 19.5305L39.8968 18.3735Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.197 18.3735L517.079 18.2469L515.838 19.4036L515.956 19.5305L517.197 18.3735Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.758 18.3735L529.64 18.2469L528.399 19.4036L528.517 19.5305L529.758 18.3735Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.318 18.3735L542.2 18.2469L540.959 19.4036L541.078 19.5305L542.318 18.3735Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 18.3735L554.76 18.2469L553.52 19.4036L553.638 19.5305L554.879 18.3735Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 18.3735L567.321 18.2469L566.08 19.4036L566.199 19.5305L567.44 18.3735Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 18.3735L579.882 18.2469L578.641 19.4036L578.759 19.5305L580 18.3735Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.852 31.3189L240.367 30.7978L235.257 35.5616L235.745 36.0854L240.852 31.3189Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.413 31.3273L252.919 30.7978L247.724 35.6412L248.22 36.1734L253.413 31.3273Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.973 31.3328L265.474 30.7978L260.225 35.6906L260.727 36.2288L265.973 31.3328Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.534 31.3346L278.033 30.7978L272.762 35.7105L273.266 36.2508L278.534 31.3346Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.094 31.3343L290.594 30.7978L285.335 35.7005L285.838 36.2397L291.094 31.3343Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.655 31.3295L303.159 30.7978L297.944 35.6602L298.442 36.1945L303.655 31.3295Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.215 31.3222L315.727 30.7978L310.587 35.5902L311.078 36.1173L316.215 31.3222Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.292 31.3078L227.818 30.7984L222.824 35.454L223.301 35.9657L228.292 31.3078Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.776 31.3117L328.297 30.7984L323.264 35.4911L323.745 36.0067L328.776 31.3117Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.733 31.293L215.272 30.799L210.424 35.3184L210.887 35.8157L215.733 31.293Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.338 31.2984L340.872 30.799L335.975 35.3642L336.443 35.866L341.338 31.2984Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.898 31.2818L353.448 30.799L348.717 35.2105L349.169 35.6954L353.898 31.2818Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.172 31.2758L202.728 30.7996L198.054 35.1563L198.501 35.6357L203.172 31.2758Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.459 31.2625L366.028 30.7996L361.489 35.0315L361.923 35.4968L366.459 31.2625Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.613 31.2559L190.188 30.8005L185.715 34.97L186.142 35.4281L190.613 31.2559Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.053 31.2342L177.649 30.8011L173.403 34.7597L173.809 35.1945L178.053 31.2342Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.021 31.2414L378.61 30.8011L374.29 34.8284L374.703 35.2714L379.021 31.2414Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.493 31.2092L165.113 30.8017L161.117 34.5276L161.499 34.9375L165.493 31.2092Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.582 31.2176L391.195 30.8017L387.117 34.6029L387.507 35.0215L391.582 31.2176Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.143 31.1911L403.781 30.8024L399.969 34.3567L400.333 34.7476L404.143 31.1911Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.933 31.1827L152.579 30.8029L148.854 34.2757L149.21 34.6572L152.933 31.1827Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.373 31.1534L140.048 30.8036L136.615 34.0035L136.943 34.3561L140.373 31.1534Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.705 31.1628L416.37 30.8036L412.843 34.0915L413.18 34.4532L416.705 31.1628Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.267 31.1333L428.961 30.8045L425.739 33.8088L426.047 34.1385L429.267 31.1333Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.814 31.1233L127.517 30.8051L124.395 33.7154L124.694 34.0355L127.814 31.1233Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.255 31.0908L114.99 30.8057L112.195 33.4113L112.463 33.6976L115.255 31.0908Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.828 31.1013L441.553 30.8057L438.653 33.509L438.93 33.8058L441.828 31.1013Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.695 31.057L102.462 30.8069L100.011 33.0925L100.246 33.3438L102.695 31.057Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.39 31.0682L454.146 30.8072L451.585 33.1943L451.831 33.4568L454.39 31.0682Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1363 31.022L89.9375 30.8084L87.8445 32.7598L88.044 32.9746L90.1363 31.022Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.952 31.0332L466.742 30.8084L464.535 32.8664L464.746 33.0925L466.952 31.0332Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.513 30.9967L479.339 30.809L477.498 32.5256L477.674 32.7142L479.513 30.9967Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5768 30.9856L77.4126 30.8096L75.6905 32.4153L75.8553 32.5919L77.5768 30.9856Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.075 30.9597L491.936 30.8102L490.476 32.1733L490.615 32.3228L492.075 30.9597Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0179 30.9479L64.8905 30.8111L63.551 32.0597L63.6793 32.1971L65.0179 30.9479Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 30.938L2.09717 30.8117L0.85622 31.9684L0.974621 32.0952L2.21497 30.938Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7757 30.938L14.6576 30.8117L13.4166 31.9684L13.5353 32.0952L14.7757 30.938Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3361 30.938L27.2183 30.8117L25.9773 31.9684L26.0957 32.0952L27.3361 30.938Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8968 30.938L39.7787 30.8117L38.5377 31.9684L38.6564 32.0952L39.8968 30.938Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4572 30.938L52.3394 30.8117L51.0985 31.9684L51.2169 32.0952L52.4572 30.938Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.637 30.938L504.519 30.8117L503.278 31.9684L503.396 32.0952L504.637 30.938Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.197 30.938L517.079 30.8117L515.838 31.9684L515.956 32.0952L517.197 30.938Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.758 30.938L529.64 30.8117L528.399 31.9684L528.517 32.0952L529.758 30.938Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.318 30.938L542.2 30.8117L540.959 31.9684L541.078 32.0952L542.318 30.938Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 30.938L554.76 30.8117L553.52 31.9684L553.638 32.0952L554.879 30.938Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 30.938L567.321 30.8117L566.08 31.9684L566.199 32.0952L567.44 30.938Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 30.938L579.882 30.8117L578.641 31.9684L578.759 32.0952L580 30.938Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.535 43.8463L278.085 43.3635L273.356 47.7726L273.809 48.2572L278.535 43.8463Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.096 43.8451L290.647 43.3638L285.928 47.7632L286.38 48.2466L291.096 43.8451Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.854 43.8312L240.419 43.3644L235.841 47.6324L236.278 48.1014L240.854 43.8312Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.414 43.8391L252.971 43.3644L248.314 47.7072L248.758 48.1845L253.414 43.8391Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.975 43.8445L265.527 43.3644L260.818 47.7539L261.268 48.2367L265.975 43.8445Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.656 43.8412L303.212 43.3644L298.534 47.725L298.981 48.2044L303.656 43.8412Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.217 43.834L315.779 43.3644L311.173 47.659L311.613 48.1309L316.217 43.834Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.733 43.8068L215.322 43.365L210.993 47.4016L211.407 47.8452L215.733 43.8068Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.294 43.8207L227.869 43.365L223.401 47.5297L223.829 47.9881L228.294 43.8207Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.778 43.824L328.35 43.365L323.845 47.5649L324.275 48.0272L328.778 43.824Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.339 43.8113L340.923 43.365L336.547 47.4453L336.965 47.8937L341.339 43.8113Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.174 43.7903L202.778 43.3656L198.614 47.2482L199.012 47.6752L203.174 43.7903Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.9 43.7963L353.499 43.3656L349.28 47.2991L349.683 47.7316L353.9 43.7963Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.614 43.7716L190.237 43.3662L186.263 47.071L186.644 47.4775L190.614 43.7716Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.461 43.7776L366.078 43.3665L362.041 47.1292L362.427 47.5432L366.461 43.7776Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.022 43.7571L378.659 43.3668L374.83 46.936L375.196 47.328L379.022 43.7571Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.054 43.7505L177.697 43.3671L173.939 46.8706L174.299 47.2554L178.054 43.7505Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.584 43.7348L391.242 43.3677L387.645 46.7211L387.989 47.09L391.584 43.7348Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.495 43.7267L165.16 43.3683L161.642 46.6491L161.977 47.0095L165.495 43.7267Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.935 43.7016L152.625 43.3689L149.366 46.4077L149.678 46.7416L152.935 43.7016Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.146 43.7095L403.828 43.3689L400.484 46.4857L400.804 46.8281L404.146 43.7095Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.707 43.6824L416.416 43.3695L413.346 46.2317L413.639 46.5466L416.707 43.6824Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.376 43.6736L140.092 43.3701L137.113 46.1476L137.397 46.4526L140.376 43.6736Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.816 43.6441L127.561 43.371L124.88 45.87L125.136 46.1452L127.816 43.6441Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.269 43.654L429.004 43.371L426.227 45.9592L426.493 46.2443L429.269 43.654Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.83 43.623L441.595 43.3716L439.129 45.6717L439.365 45.9243L441.83 43.623Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.257 43.613L115.032 43.3723L112.667 45.5771L112.893 45.8197L115.257 43.613Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.697 43.5805L102.504 43.3728L100.47 45.2697L100.664 45.4779L102.697 43.5805Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.392 43.5913L454.188 43.3728L452.048 45.3682L452.253 45.5876L454.392 43.5913Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1375 43.5461L89.9775 43.3744L88.2892 44.9481L88.4507 45.1214L90.1375 43.5461Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.953 43.5576L466.782 43.3744L464.983 45.0506L465.155 45.2353L466.953 43.5576Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.515 43.5223L479.378 43.375L477.934 44.7206L478.072 44.8686L479.515 43.5223Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5783 43.5112L77.4521 43.3756L76.1232 44.6142L76.25 44.7504L77.5783 43.5112Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 43.5024L2.09717 43.3762L0.85622 44.5328L0.974621 44.6597L2.21497 43.5024Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7757 43.5024L14.6576 43.3762L13.4166 44.5328L13.5353 44.6597L14.7757 43.5024Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3361 43.5024L27.2183 43.3762L25.9773 44.5328L26.0957 44.6597L27.3361 43.5024Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8968 43.5024L39.7787 43.3762L38.5377 44.5328L38.6564 44.6597L39.8968 43.5024Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4572 43.5024L52.3394 43.3762L51.0985 44.5328L51.2169 44.6597L52.4572 43.5024Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0185 43.5024L64.9004 43.3762L63.6595 44.5328L63.7779 44.6597L65.0185 43.5024Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.076 43.5024L491.958 43.3762L490.717 44.5328L490.835 44.6597L492.076 43.5024Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.637 43.5024L504.519 43.3762L503.278 44.5328L503.396 44.6597L504.637 43.5024Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.197 43.5024L517.079 43.3762L515.838 44.5328L515.956 44.6597L517.197 43.5024Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.758 43.5024L529.64 43.3762L528.399 44.5328L528.517 44.6597L529.758 43.5024Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.318 43.5024L542.2 43.3762L540.959 44.5328L541.078 44.6597L542.318 43.5024Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 43.5024L554.76 43.3762L553.52 44.5328L553.638 44.6597L554.879 43.5024Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 43.5024L567.321 43.3762L566.08 44.5328L566.199 44.6597L567.44 43.5024Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 43.5024L579.882 43.3762L578.641 44.5328L578.759 44.6597L580 43.5024Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.977 56.3553L265.58 55.9301L261.412 59.8166L261.81 60.2445L265.977 56.3553Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.537 56.3574L278.139 55.9301L273.951 59.8347L274.352 60.2638L278.537 56.3574Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.097 56.3562L290.701 55.9304L286.523 59.8253L286.922 60.2539L291.097 56.3562Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.658 56.3529L303.265 55.9304L299.126 59.7895L299.522 60.2135L303.658 56.3529Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.856 56.3436L240.471 55.931L236.428 59.7018L236.814 60.1161L240.856 56.3436Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.417 56.3508L253.025 55.931L248.904 59.7723L249.297 60.1948L253.417 56.3508Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.219 56.3463L315.832 55.931L311.761 59.7268L312.15 60.1442L316.219 56.3463Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.78 56.3363L328.402 55.931L324.426 59.6382L324.806 60.0456L328.78 56.3363Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.736 56.3198L215.374 55.9316L211.565 59.483L211.928 59.8735L215.736 56.3198Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.296 56.333L227.921 55.9316L223.981 59.6044L224.357 60.0085L228.296 56.333Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.341 56.3243L340.974 55.9316L337.121 59.5237L337.489 59.9191L341.341 56.3243Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.175 56.3047L202.828 55.9322L199.177 59.3365L199.526 59.7108L203.175 56.3047Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.902 56.3098L353.55 55.9322L349.845 59.3856L350.199 59.765L353.902 56.3098Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.616 56.2869L190.286 55.9331L186.817 59.168L187.148 59.523L190.616 56.2869Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.463 56.2926L366.127 55.9331L362.598 59.2235L362.935 59.5854L366.463 56.2926Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.056 56.2661L177.746 55.9337L174.482 58.977L174.794 59.3115L178.056 56.2661Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.024 56.2728L378.708 55.9337L375.376 59.039L375.694 59.3808L379.024 56.2728Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.496 56.2438L165.208 55.9343L162.171 58.7645L162.462 59.0761L165.496 56.2438Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.586 56.2511L391.29 55.9343L388.18 58.8341L388.477 59.1527L391.586 56.2511Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.147 56.2272L403.875 55.9349L401.007 58.6087L401.28 58.9028L404.147 56.2272Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.937 56.2194L152.672 55.9355L149.885 58.5339L150.151 58.8196L152.937 56.2194Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.708 56.2013L416.461 55.9355L413.855 58.3646L414.104 58.6316L416.708 56.2013Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.377 56.1929L140.138 55.9361L137.619 58.2838L137.86 58.5424L140.377 56.1929Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.817 56.1643L127.605 55.9367L125.374 58.0174L125.587 58.2461L127.817 56.1643Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.27 56.1736L429.049 55.9367L426.725 58.1033L426.947 58.3414L429.27 56.1736Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.831 56.1447L441.639 55.9376L439.614 57.8257L439.807 58.0334L441.831 56.1447Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.258 56.1347L115.075 55.9382L113.148 57.735L113.331 57.9327L115.258 56.1347Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.393 56.1133L454.23 55.9388L452.521 57.5331L452.684 57.7085L454.393 56.1133Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.699 56.1028L102.546 55.9394L100.938 57.4382L101.092 57.6027L102.699 56.1028Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1387 56.0705L90.0176 55.9403L88.745 57.1271L88.8667 57.2576L90.1387 56.0705Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.955 56.0811L466.823 55.9403L465.444 57.2266L465.576 57.3679L466.955 56.0811Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 56.0672L2.09717 55.9409L0.85622 57.0976L0.974621 57.2245L2.21497 56.0672Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7757 56.0672L14.6576 55.9409L13.4166 57.0976L13.5353 57.2245L14.7757 56.0672Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3361 56.0672L27.2183 55.9409L25.9773 57.0976L26.0957 57.2245L27.3361 56.0672Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8968 56.0672L39.7787 55.9409L38.5377 57.0976L38.6564 57.2245L39.8968 56.0672Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4572 56.0672L52.3394 55.9409L51.0985 57.0976L51.2169 57.2245L52.4572 56.0672Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0185 56.0672L64.9004 55.9409L63.6595 57.0976L63.7779 57.2245L65.0185 56.0672Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5792 56.0672L77.4608 55.9409L76.2202 57.0976L76.3383 57.2245L77.5792 56.0672Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.516 56.0672L479.397 55.9409L478.157 57.0976L478.275 57.2245L479.516 56.0672Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.076 56.0672L491.958 55.9409L490.717 57.0976L490.835 57.2245L492.076 56.0672Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.637 56.0672L504.519 55.9409L503.278 57.0976L503.396 57.2245L504.637 56.0672Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.197 56.0672L517.079 55.9409L515.838 57.0976L515.956 57.2245L517.197 56.0672Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.758 56.0672L529.64 55.9409L528.399 57.0976L528.517 57.2245L529.758 56.0672Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.318 56.0672L542.2 55.9409L540.959 57.0976L541.078 57.2245L542.318 56.0672Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 56.0672L554.76 55.9409L553.52 57.0976L553.638 57.2245L554.879 56.0672Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 56.0672L567.321 55.9409L566.08 57.0976L566.199 57.2245L567.44 56.0672Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 56.0672L579.882 55.9409L578.641 57.0976L578.759 57.2245L580 56.0672Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.418 68.8625L253.077 68.497L249.494 71.8377L249.837 72.2048L253.418 68.8625Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.978 68.8674L265.633 68.497L262.005 71.8802L262.351 72.2518L265.978 68.8674Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.539 68.8686L278.193 68.497L274.546 71.8965L274.895 72.2702L278.539 68.8686Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.1 68.868L290.754 68.497L287.116 71.888L287.464 72.2611L291.1 68.868Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.66 68.8638L303.318 68.497L299.717 71.8537L300.061 72.2225L303.66 68.8638Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.297 68.8454L227.974 68.4976L224.562 71.6783L224.888 72.0275L228.297 68.8454Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.858 68.8553L240.524 68.4976L237.014 71.7702L237.349 72.13L240.858 68.8553Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.221 68.858L315.885 68.4976L312.349 71.7943L312.686 72.1565L316.221 68.858Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.782 68.8487L328.455 68.4976L325.009 71.7093L325.338 72.0631L328.782 68.8487Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.738 68.8333L215.425 68.4982L212.139 71.5619L212.453 71.8992L215.738 68.8333Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.343 68.8375L341.026 68.4982L337.698 71.6011L338.015 71.9423L341.343 68.8375Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.903 68.8234L353.601 68.4982L350.414 71.4694L350.719 71.7961L353.903 68.8234Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.178 68.8182L202.88 68.4988L199.743 71.423L200.043 71.7446L203.178 68.8182Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.465 68.8068L366.178 68.4988L363.158 71.3145L363.447 71.624L366.465 68.8068Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.618 68.8011L190.336 68.4994L187.373 71.2618L187.656 71.5652L190.618 68.8011Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.026 68.7884L378.757 68.4994L375.926 71.1388L376.197 71.429L379.026 68.7884Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.058 68.7818L177.795 68.5L175.029 71.0785L175.293 71.3621L178.058 68.7818Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.587 68.7673L391.339 68.5L388.719 70.9423L388.97 71.2108L391.587 68.7673Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.498 68.7607L165.255 68.5009L162.707 70.8763L162.951 71.1373L165.498 68.7607Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.938 68.7369L152.719 68.5015L150.409 70.6539L150.63 70.8908L152.938 68.7369Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.149 68.745L403.921 68.5015L401.535 70.7262L401.763 70.9709L404.149 68.745Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.378 68.7119L140.183 68.5021L138.133 70.4146L138.329 70.625L140.378 68.7119Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.71 68.7197L416.507 68.5021L414.373 70.4921L414.577 70.7109L416.71 68.7197Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.272 68.6932L429.094 68.5027L427.231 70.2407L427.409 70.4318L429.272 68.6932Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.819 68.6841L127.65 68.5036L125.875 70.1581L126.045 70.3399L127.819 68.6841Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.259 68.6555L115.119 68.5042L113.637 69.8857L113.779 70.037L115.259 68.6555Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.833 68.6648L441.683 68.5042L440.108 69.9728L440.258 70.1349L441.833 68.6648Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.394 68.6344L454.274 68.5048L453.002 69.6904L453.124 69.8209L454.394 68.6344Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 68.6317L2.09717 68.5054L0.85622 69.6621L0.974621 69.789L2.21497 68.6317Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7757 68.6317L14.6576 68.5054L13.4166 69.6621L13.5353 69.789L14.7757 68.6317Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3361 68.6317L27.2183 68.5054L25.9773 69.6621L26.0957 69.789L27.3361 68.6317Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8968 68.6317L39.7787 68.5054L38.5377 69.6621L38.6564 69.789L39.8968 68.6317Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4572 68.6317L52.3394 68.5054L51.0985 69.6621L51.2169 69.789L52.4572 68.6317Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0185 68.6317L64.9004 68.5054L63.6595 69.6621L63.7779 69.789L65.0185 68.6317Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5792 68.6317L77.4608 68.5054L76.2202 69.6621L76.3383 69.789L77.5792 68.6317Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1396 68.6317L90.0212 68.5054L88.7806 69.6621L88.899 69.789L90.1396 68.6317Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.7 68.6317L102.582 68.5054L101.341 69.6621L101.459 69.789L102.7 68.6317Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.955 68.6317L466.837 68.5054L465.596 69.6621L465.714 69.789L466.955 68.6317Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.516 68.6317L479.397 68.5054L478.157 69.6621L478.275 69.789L479.516 68.6317Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.076 68.6317L491.958 68.5054L490.717 69.6621L490.835 69.789L492.076 68.6317Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.637 68.6317L504.519 68.5054L503.278 69.6621L503.396 69.789L504.637 68.6317Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.197 68.6317L517.079 68.5054L515.838 69.6621L515.956 69.789L517.197 68.6317Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.758 68.6317L529.64 68.5054L528.399 69.6621L528.517 69.789L529.758 68.6317Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.318 68.6317L542.2 68.5054L540.959 69.6621L541.078 69.789L542.318 68.6317Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 68.6317L554.76 68.5054L553.52 69.6621L553.638 69.789L554.879 68.6317Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 68.6317L567.321 68.5054L566.08 69.6621L566.199 69.789L567.44 68.6317Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 68.6317L579.882 68.5054L578.641 69.6621L578.759 69.789L580 68.6317Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.42 81.3743L253.131 81.0636L250.086 83.9025L250.377 84.2144L253.42 81.3743Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.98 81.3782L265.687 81.0636L262.598 83.9429L262.894 84.2596L265.98 81.3782Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.541 81.3803L278.245 81.0636L275.14 83.9585L275.437 84.2768L278.541 81.3803Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.102 81.3788L290.808 81.0636L287.711 83.9501L288.007 84.2674L291.102 81.3788Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.662 81.3758L303.371 81.0636L300.31 83.9175L300.603 84.2319L303.662 81.3758Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.222 81.3698L315.937 81.0636L312.937 83.8609L313.224 84.1683L316.222 81.3698Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.299 81.3577L228.026 81.0642L225.144 83.7503L225.42 84.0459L228.299 81.3577Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.86 81.367L240.577 81.0642L237.601 83.8383L237.885 84.143L240.86 81.367Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.784 81.361L328.507 81.0642L325.593 83.7807L325.871 84.0797L328.784 81.361Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.344 81.3505L341.078 81.0642L338.275 83.6768L338.543 83.9646L341.344 81.3505Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.179 81.3318L202.931 81.0648L200.312 83.5068L200.562 83.7753L203.179 81.3318Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.739 81.3465L215.476 81.0648L212.714 83.64L212.979 83.923L215.739 81.3465Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.905 81.3366L353.652 81.0648L350.986 83.5514L351.24 83.8244L353.905 81.3366Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.466 81.3215L366.228 81.0654L363.72 83.4037L363.96 83.6605L366.466 81.3215Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.619 81.3155L190.386 81.0657L187.933 83.3522L188.167 83.6041L190.619 81.3155Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.059 81.2968L177.845 81.066L175.58 83.1777L175.796 83.4097L178.059 81.2968Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.028 81.3035L378.806 81.0663L376.48 83.2352L376.703 83.4733L379.028 81.3035Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.499 81.2763L165.304 81.0669L163.249 82.9833L163.445 83.1934L165.499 81.2763Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.589 81.283L391.387 81.0669L389.263 83.0466L389.466 83.2642L391.589 81.283Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.15 81.2613L403.97 81.0675L402.069 82.8389L402.251 83.0342L404.15 81.2613Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.94 81.254L152.766 81.0681L150.94 82.7702L151.115 82.9574L152.94 81.254Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.711 81.2375L416.554 81.0681L414.896 82.6141L415.055 82.7841L416.711 81.2375Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.38 81.2293L140.23 81.0687L138.653 82.5394L138.803 82.7006L140.38 81.2293Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.821 81.2031L127.696 81.0696L126.385 82.2923L126.51 82.4264L127.821 81.2031Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.273 81.2115L429.14 81.0696L427.743 82.3721L427.876 82.515L429.273 81.2115Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 81.1965L2.09717 81.0702L0.85622 82.2266L0.974621 82.3537L2.21497 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7757 81.1965L14.6576 81.0702L13.4166 82.2266L13.5353 82.3537L14.7757 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3361 81.1965L27.2183 81.0702L25.9773 82.2266L26.0957 82.3537L27.3361 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8968 81.1965L39.7787 81.0702L38.5377 82.2266L38.6564 82.3537L39.8968 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4572 81.1965L52.3394 81.0702L51.0985 82.2266L51.2169 82.3537L52.4572 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0185 81.1965L64.9004 81.0702L63.6595 82.2266L63.7779 82.3537L65.0185 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5792 81.1965L77.4608 81.0702L76.2202 82.2266L76.3383 82.3537L77.5792 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1396 81.1965L90.0212 81.0702L88.7806 82.2266L88.899 82.3537L90.1396 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.7 81.1965L102.582 81.0702L101.341 82.2266L101.459 82.3537L102.7 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.261 81.1965L115.142 81.0702L113.902 82.2266L114.02 82.3537L115.261 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.834 81.1965L441.716 81.0702L440.475 82.2266L440.593 82.3537L441.834 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.395 81.1965L454.276 81.0702L453.035 82.2266L453.154 82.3537L454.395 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.955 81.1965L466.837 81.0702L465.596 82.2266L465.714 82.3537L466.955 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.516 81.1965L479.397 81.0702L478.157 82.2266L478.275 82.3537L479.516 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.076 81.1965L491.958 81.0702L490.717 82.2266L490.835 82.3537L492.076 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.637 81.1965L504.519 81.0702L503.278 82.2266L503.396 82.3537L504.637 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.197 81.1965L517.079 81.0702L515.838 82.2266L515.956 82.3537L517.197 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.758 81.1965L529.64 81.0702L528.399 82.2266L528.517 82.3537L529.758 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.318 81.1965L542.2 81.0702L540.959 82.2266L541.078 82.3537L542.318 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 81.1965L554.76 81.0702L553.52 82.2266L553.638 82.3537L554.879 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 81.1965L567.321 81.0702L566.08 82.2266L566.199 82.3537L567.44 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 81.1965L579.882 81.0702L578.641 82.2266L578.759 82.3537L580 81.1965Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.861 93.8794L240.63 93.6301L238.189 95.9055L238.422 96.1556L240.861 93.8794Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.422 93.8854L253.184 93.6301L250.677 95.967L250.916 96.2238L253.422 93.8854Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.982 93.8899L265.739 93.6301L263.192 96.0056L263.436 96.2665L265.982 93.8899Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.543 93.8911L278.299 93.6301L275.735 96.0206L275.98 96.2831L278.543 93.8911Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.103 93.8905L290.86 93.6301L288.304 96.0128L288.549 96.2747L291.103 93.8905Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.664 93.8872L303.424 93.6301L300.902 95.9818L301.142 96.24L303.664 93.8872Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.225 93.8812L315.99 93.6301L313.527 95.9275L313.762 96.1801L316.225 93.8812Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.741 93.8589L215.529 93.6308L213.292 95.7156L213.506 95.9453L215.741 93.8589Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.301 93.87L228.078 93.6308L225.728 95.8214L225.952 96.0628L228.301 93.87Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.786 93.8734L328.559 93.6308L326.178 95.8507L326.405 96.0948L328.786 93.8734Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.346 93.8628L341.13 93.6308L338.855 95.7515L339.073 95.9851L341.346 93.8628Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.181 93.8456L202.981 93.6314L200.882 95.5888L201.083 95.8036L203.181 93.8456Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.907 93.8505L353.703 93.6314L351.558 95.6313L351.763 95.8513L353.907 93.8505Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.621 93.8297L190.437 93.632L188.496 95.4408L188.682 95.6397L190.621 93.8297Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.468 93.8351L366.278 93.632L364.285 95.4896L364.476 95.6939L366.468 93.8351Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.061 93.8119L177.894 93.6329L176.134 95.2735L176.302 95.454L178.061 93.8119Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.03 93.8179L378.856 93.6329L377.037 95.3284L377.211 95.5149L379.03 93.8179Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.501 93.792L165.353 93.6335L163.794 95.0864L163.943 95.2464L165.501 93.792Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.591 93.7989L391.436 93.6335L389.812 95.1479L389.967 95.3139L391.591 93.7989Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.942 93.7703L152.815 93.6341L151.476 94.882L151.604 95.0189L152.942 93.7703Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.152 93.7775L404.018 93.6341L402.608 94.948L402.743 95.0927L404.152 93.7775Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 93.7609L2.09717 93.6347L0.85622 94.7913L0.974621 94.9182L2.21497 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7757 93.7609L14.6576 93.6347L13.4166 94.7913L13.5353 94.9182L14.7757 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3361 93.7609L27.2183 93.6347L25.9773 94.7913L26.0957 94.9182L27.3361 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8968 93.7609L39.7787 93.6347L38.5377 94.7913L38.6564 94.9182L39.8968 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4572 93.7609L52.3394 93.6347L51.0985 94.7913L51.2169 94.9182L52.4572 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0185 93.7609L64.9004 93.6347L63.6595 94.7913L63.7779 94.9182L65.0185 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5792 93.7609L77.4608 93.6347L76.2202 94.7913L76.3383 94.9182L77.5792 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1396 93.7609L90.0212 93.6347L88.7806 94.7913L88.899 94.9182L90.1396 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.7 93.7609L102.582 93.6347L101.341 94.7913L101.459 94.9182L102.7 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.261 93.7609L115.142 93.6347L113.902 94.7913L114.02 94.9182L115.261 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.821 93.7609L127.703 93.6347L126.462 94.7913L126.58 94.9182L127.821 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.382 93.7609L140.263 93.6347L139.023 94.7913L139.141 94.9182L140.382 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.713 93.7609L416.595 93.6347L415.354 94.7913L415.472 94.9182L416.713 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.274 93.7609L429.155 93.6347L427.914 94.7913L428.033 94.9182L429.274 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.834 93.7609L441.716 93.6347L440.475 94.7913L440.593 94.9182L441.834 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.395 93.7609L454.276 93.6347L453.035 94.7913L453.154 94.9182L454.395 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.955 93.7609L466.837 93.6347L465.596 94.7913L465.714 94.9182L466.955 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.516 93.7609L479.397 93.6347L478.157 94.7913L478.275 94.9182L479.516 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.076 93.7609L491.958 93.6347L490.717 94.7913L490.835 94.9182L492.076 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.637 93.7609L504.519 93.6347L503.278 94.7913L503.396 94.9182L504.637 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.197 93.7609L517.079 93.6347L515.838 94.7913L515.956 94.9182L517.197 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.758 93.7609L529.64 93.6347L528.399 94.7913L528.517 94.9182L529.758 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.318 93.7609L542.2 93.6347L540.959 94.7913L541.078 94.9182L542.318 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 93.7609L554.76 93.6347L553.52 94.7913L553.638 94.9182L554.879 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 93.7609L567.321 93.6347L566.08 94.7913L566.199 94.9182L567.44 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 93.7609L579.882 93.6347L578.641 94.7913L578.759 94.9182L580 93.7609Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.544 106.402L278.352 106.196L276.329 108.083L276.522 108.289L278.544 106.402Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.863 106.391L240.682 106.197L238.778 107.972L238.959 108.168L240.863 106.391Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.424 106.397L253.237 106.197L251.269 108.031L251.457 108.233L253.424 106.397Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.984 106.401L265.793 106.197L263.786 108.068L263.978 108.274L265.984 106.401Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.106 106.402L290.914 106.197L288.899 108.075L289.091 108.282L291.106 106.402Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.666 106.398L303.478 106.197L301.494 108.045L301.684 108.248L303.666 106.398Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.226 106.393L316.043 106.197L314.116 107.994L314.3 108.191L316.226 106.393Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.787 106.385L328.611 106.197L326.763 107.92L326.94 108.109L328.787 106.385Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.743 106.372L215.58 106.197L213.871 107.791L214.035 107.966L215.743 106.372Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.303 106.383L228.13 106.197L226.311 107.892L226.485 108.079L228.303 106.383Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.348 106.375L341.182 106.197L339.436 107.825L339.603 108.004L341.348 106.375Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.183 106.359L203.033 106.198L201.455 107.67L201.606 107.831L203.183 106.359Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.909 106.363L353.755 106.198L352.133 107.71L352.287 107.876L353.909 106.363Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.47 106.349L366.33 106.198L364.853 107.574L364.995 107.726L366.47 106.349Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.062 106.327L177.943 106.199L176.692 107.366L176.812 107.495L178.062 106.327Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.623 106.344L190.487 106.199L189.061 107.527L189.198 107.673L190.623 106.344Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.031 106.332L378.907 106.199L377.598 107.419L377.723 107.554L379.031 106.332Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 106.325L2.09717 106.199L0.85622 107.356L0.974621 107.483L2.21497 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7757 106.325L14.6576 106.199L13.4166 107.356L13.5353 107.483L14.7757 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3361 106.325L27.2183 106.199L25.9773 107.356L26.0957 107.483L27.3361 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8968 106.325L39.7787 106.199L38.5377 107.356L38.6564 107.483L39.8968 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4572 106.325L52.3394 106.199L51.0985 107.356L51.2169 107.483L52.4572 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0185 106.325L64.9004 106.199L63.6595 107.356L63.7779 107.483L65.0185 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5792 106.325L77.4608 106.199L76.2202 107.356L76.3383 107.483L77.5792 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1396 106.325L90.0212 106.199L88.7806 107.356L88.899 107.483L90.1396 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.7 106.325L102.582 106.199L101.341 107.356L101.459 107.483L102.7 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.261 106.325L115.142 106.199L113.902 107.356L114.02 107.483L115.261 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.821 106.325L127.703 106.199L126.462 107.356L126.58 107.483L127.821 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.382 106.325L140.263 106.199L139.023 107.356L139.141 107.483L140.382 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.942 106.325L152.824 106.199L151.583 107.356L151.702 107.483L152.942 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.502 106.325L165.384 106.199L164.143 107.356L164.261 107.483L165.502 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.592 106.325L391.474 106.199L390.233 107.356L390.351 107.483L391.592 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.153 106.325L404.034 106.199L402.793 107.356L402.912 107.483L404.153 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.713 106.325L416.595 106.199L415.354 107.356L415.472 107.483L416.713 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.274 106.325L429.155 106.199L427.914 107.356L428.033 107.483L429.274 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.834 106.325L441.716 106.199L440.475 107.356L440.593 107.483L441.834 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.395 106.325L454.276 106.199L453.035 107.356L453.154 107.483L454.395 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.955 106.325L466.837 106.199L465.596 107.356L465.714 107.483L466.955 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.516 106.325L479.397 106.199L478.157 107.356L478.275 107.483L479.516 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.076 106.325L491.958 106.199L490.717 107.356L490.835 107.483L492.076 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.637 106.325L504.519 106.199L503.278 107.356L503.396 107.483L504.637 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.197 106.325L517.079 106.199L515.838 107.356L515.956 107.483L517.197 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.758 106.325L529.64 106.199L528.399 107.356L528.517 107.483L529.758 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.318 106.325L542.2 106.199L540.959 107.356L541.078 107.483L542.318 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 106.325L554.76 106.199L553.52 107.356L553.638 107.483L554.879 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 106.325L567.321 106.199L566.08 107.356L566.199 107.483L567.44 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 106.325L579.882 106.199L578.641 107.356L578.759 107.483L580 106.325Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.546 118.914L278.405 118.762L276.923 120.145L277.065 120.296L278.546 118.914Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.667 118.91L303.53 118.762L302.086 120.108L302.225 120.256L303.667 118.91Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.985 118.913L265.846 118.763L264.38 120.13L264.52 120.281L265.985 118.913Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.106 118.913L290.966 118.763L289.493 120.137L289.634 120.288L291.106 118.913Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.228 118.905L316.096 118.763L314.706 120.059L314.839 120.201L316.228 118.905Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.305 118.895L228.182 118.763L226.897 119.962L227.02 120.094L228.305 118.895Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.865 118.903L240.735 118.763L239.366 120.039L239.497 120.179L240.865 118.903Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.426 118.909L253.29 118.763L251.86 120.095L251.997 120.242L253.426 118.909Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.789 118.897L328.664 118.763L327.35 119.989L327.476 120.123L328.789 118.897Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 118.89L2.09717 118.764L0.85622 119.921L0.974621 120.047L2.21497 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7757 118.89L14.6576 118.764L13.4166 119.921L13.5353 120.047L14.7757 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3361 118.89L27.2183 118.764L25.9773 119.921L26.0957 120.047L27.3361 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8968 118.89L39.7787 118.764L38.5377 119.921L38.6564 120.047L39.8968 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4572 118.89L52.3394 118.764L51.0985 119.921L51.2169 120.047L52.4572 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0185 118.89L64.9004 118.764L63.6595 119.921L63.7779 120.047L65.0185 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5792 118.89L77.4608 118.764L76.2202 119.921L76.3383 120.047L77.5792 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1396 118.89L90.0212 118.764L88.7806 119.921L88.899 120.047L90.1396 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.7 118.89L102.582 118.764L101.341 119.921L101.459 120.047L102.7 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.261 118.89L115.142 118.764L113.902 119.921L114.02 120.047L115.261 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.821 118.89L127.703 118.764L126.462 119.921L126.58 120.047L127.821 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.382 118.89L140.263 118.764L139.023 119.921L139.141 120.047L140.382 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.942 118.89L152.824 118.764L151.583 119.921L151.702 120.047L152.942 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.502 118.89L165.384 118.764L164.143 119.921L164.261 120.047L165.502 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.063 118.89L177.944 118.764L176.704 119.921L176.822 120.047L178.063 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.623 118.89L190.505 118.764L189.264 119.921L189.383 120.047L190.623 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.184 118.89L203.065 118.764L201.825 119.921L201.943 120.047L203.184 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.744 118.89L215.626 118.764L214.385 119.921L214.504 120.047L215.744 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.35 118.89L341.231 118.764L339.991 119.921L340.109 120.047L341.35 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.911 118.89L353.792 118.764L352.551 119.921L352.67 120.047L353.911 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.471 118.89L366.353 118.764L365.112 119.921L365.23 120.047L366.471 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.031 118.89L378.913 118.764L377.672 119.921L377.79 120.047L379.031 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.592 118.89L391.474 118.764L390.233 119.921L390.351 120.047L391.592 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.153 118.89L404.034 118.764L402.793 119.921L402.912 120.047L404.153 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.713 118.89L416.595 118.764L415.354 119.921L415.472 120.047L416.713 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.274 118.89L429.155 118.764L427.914 119.921L428.033 120.047L429.274 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.834 118.89L441.716 118.764L440.475 119.921L440.593 120.047L441.834 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.395 118.89L454.276 118.764L453.035 119.921L453.154 120.047L454.395 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.955 118.89L466.837 118.764L465.596 119.921L465.714 120.047L466.955 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.516 118.89L479.397 118.764L478.157 119.921L478.275 120.047L479.516 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.076 118.89L491.958 118.764L490.717 119.921L490.835 120.047L492.076 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.637 118.89L504.519 118.764L503.278 119.921L503.396 120.047L504.637 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.197 118.89L517.079 118.764L515.838 119.921L515.956 120.047L517.197 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.758 118.89L529.64 118.764L528.399 119.921L528.517 120.047L529.758 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.318 118.89L542.2 118.764L540.959 119.921L541.078 120.047L542.318 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 118.89L554.76 118.764L553.52 119.921L553.638 120.047L554.879 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 118.89L567.321 118.764L566.08 119.921L566.199 120.047L567.44 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 118.89L579.882 118.764L578.641 119.921L578.759 120.047L580 118.89Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 131.455L2.09717 131.328L0.85622 132.485L0.974621 132.612L2.21497 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7757 131.455L14.6576 131.328L13.4166 132.485L13.5353 132.612L14.7757 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3361 131.455L27.2183 131.328L25.9773 132.485L26.0957 132.612L27.3361 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8968 131.455L39.7787 131.328L38.5377 132.485L38.6564 132.612L39.8968 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4572 131.455L52.3394 131.328L51.0985 132.485L51.2169 132.612L52.4572 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0185 131.455L64.9004 131.328L63.6595 132.485L63.7779 132.612L65.0185 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5792 131.455L77.4608 131.328L76.2202 132.485L76.3383 132.612L77.5792 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1396 131.455L90.0212 131.328L88.7806 132.485L88.899 132.612L90.1396 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.7 131.455L102.582 131.328L101.341 132.485L101.459 132.612L102.7 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.261 131.455L115.142 131.328L113.902 132.485L114.02 132.612L115.261 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.821 131.455L127.703 131.328L126.462 132.485L126.58 132.612L127.821 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.382 131.455L140.263 131.328L139.023 132.485L139.141 132.612L140.382 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.942 131.455L152.824 131.328L151.583 132.485L151.702 132.612L152.942 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.502 131.455L165.384 131.328L164.143 132.485L164.261 132.612L165.502 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.063 131.455L177.944 131.328L176.704 132.485L176.822 132.612L178.063 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.623 131.455L190.505 131.328L189.264 132.485L189.383 132.612L190.623 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.184 131.455L203.065 131.328L201.825 132.485L201.943 132.612L203.184 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.744 131.455L215.626 131.328L214.385 132.485L214.504 132.612L215.744 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.305 131.455L228.187 131.328L226.946 132.485L227.064 132.612L228.305 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.865 131.455L240.747 131.328L239.506 132.485L239.625 132.612L240.865 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.426 131.455L253.308 131.328L252.067 132.485L252.185 132.612L253.426 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.987 131.455L265.868 131.328L264.627 132.485L264.746 132.612L265.987 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.547 131.455L278.429 131.328L277.188 132.485L277.306 132.612L278.547 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.108 131.455L290.989 131.328L289.749 132.485L289.867 132.612L291.108 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.668 131.455L303.55 131.328L302.309 132.485L302.427 132.612L303.668 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.229 131.455L316.11 131.328L314.87 132.485L314.988 132.612L316.229 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.789 131.455L328.671 131.328L327.43 132.485L327.549 132.612L328.789 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.35 131.455L341.231 131.328L339.991 132.485L340.109 132.612L341.35 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.911 131.455L353.792 131.328L352.551 132.485L352.67 132.612L353.911 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.471 131.455L366.353 131.328L365.112 132.485L365.23 132.612L366.471 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.031 131.455L378.913 131.328L377.672 132.485L377.79 132.612L379.031 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.592 131.455L391.474 131.328L390.233 132.485L390.351 132.612L391.592 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.153 131.455L404.034 131.328L402.793 132.485L402.912 132.612L404.153 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.713 131.455L416.595 131.328L415.354 132.485L415.472 132.612L416.713 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.274 131.455L429.155 131.328L427.914 132.485L428.033 132.612L429.274 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.834 131.455L441.716 131.328L440.475 132.485L440.593 132.612L441.834 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.395 131.455L454.276 131.328L453.035 132.485L453.154 132.612L454.395 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.955 131.455L466.837 131.328L465.596 132.485L465.714 132.612L466.955 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.516 131.455L479.397 131.328L478.157 132.485L478.275 132.612L479.516 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.076 131.455L491.958 131.328L490.717 132.485L490.835 132.612L492.076 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.637 131.455L504.519 131.328L503.278 132.485L503.396 132.612L504.637 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.197 131.455L517.079 131.328L515.838 132.485L515.956 132.612L517.197 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.758 131.455L529.64 131.328L528.399 132.485L528.517 132.612L529.758 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.318 131.455L542.2 131.328L540.959 132.485L541.078 132.612L542.318 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 131.455L554.76 131.328L553.52 132.485L553.638 132.612L554.879 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 131.455L567.321 131.328L566.08 132.485L566.199 132.612L567.44 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 131.455L579.882 131.328L578.641 132.485L578.759 132.612L580 131.455Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 144.019L2.09717 143.893L0.85622 145.05L0.974621 145.177L2.21497 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7757 144.019L14.6576 143.893L13.4166 145.05L13.5353 145.177L14.7757 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3361 144.019L27.2183 143.893L25.9773 145.05L26.0957 145.177L27.3361 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8968 144.019L39.7787 143.893L38.5377 145.05L38.6564 145.177L39.8968 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4572 144.019L52.3394 143.893L51.0985 145.05L51.2169 145.177L52.4572 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0185 144.019L64.9004 143.893L63.6595 145.05L63.7779 145.177L65.0185 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5792 144.019L77.4608 143.893L76.2202 145.05L76.3383 145.177L77.5792 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1396 144.019L90.0212 143.893L88.7806 145.05L88.899 145.177L90.1396 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.7 144.019L102.582 143.893L101.341 145.05L101.459 145.177L102.7 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.261 144.019L115.142 143.893L113.902 145.05L114.02 145.177L115.261 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.821 144.019L127.703 143.893L126.462 145.05L126.58 145.177L127.821 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.382 144.019L140.263 143.893L139.023 145.05L139.141 145.177L140.382 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.942 144.019L152.824 143.893L151.583 145.05L151.702 145.177L152.942 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.502 144.019L165.384 143.893L164.143 145.05L164.261 145.177L165.502 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.063 144.019L177.944 143.893L176.704 145.05L176.822 145.177L178.063 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.623 144.019L190.505 143.893L189.264 145.05L189.383 145.177L190.623 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.184 144.019L203.065 143.893L201.825 145.05L201.943 145.177L203.184 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.744 144.019L215.626 143.893L214.385 145.05L214.504 145.177L215.744 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.305 144.019L228.187 143.893L226.946 145.05L227.064 145.177L228.305 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.865 144.019L240.747 143.893L239.506 145.05L239.625 145.177L240.865 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.426 144.019L253.308 143.893L252.067 145.05L252.185 145.177L253.426 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.987 144.019L265.868 143.893L264.627 145.05L264.746 145.177L265.987 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.547 144.019L278.429 143.893L277.188 145.05L277.306 145.177L278.547 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.108 144.019L290.989 143.893L289.749 145.05L289.867 145.177L291.108 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.668 144.019L303.55 143.893L302.309 145.05L302.427 145.177L303.668 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.229 144.019L316.11 143.893L314.87 145.05L314.988 145.177L316.229 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.789 144.019L328.671 143.893L327.43 145.05L327.549 145.177L328.789 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.35 144.019L341.231 143.893L339.991 145.05L340.109 145.177L341.35 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.911 144.019L353.792 143.893L352.551 145.05L352.67 145.177L353.911 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.471 144.019L366.353 143.893L365.112 145.05L365.23 145.177L366.471 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.031 144.019L378.913 143.893L377.672 145.05L377.79 145.177L379.031 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.592 144.019L391.474 143.893L390.233 145.05L390.351 145.177L391.592 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.153 144.019L404.034 143.893L402.793 145.05L402.912 145.177L404.153 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.713 144.019L416.595 143.893L415.354 145.05L415.472 145.177L416.713 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.274 144.019L429.155 143.893L427.914 145.05L428.033 145.177L429.274 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.834 144.019L441.716 143.893L440.475 145.05L440.593 145.177L441.834 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.395 144.019L454.276 143.893L453.035 145.05L453.154 145.177L454.395 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.955 144.019L466.837 143.893L465.596 145.05L465.714 145.177L466.955 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.516 144.019L479.397 143.893L478.157 145.05L478.275 145.177L479.516 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.076 144.019L491.958 143.893L490.717 145.05L490.835 145.177L492.076 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.637 144.019L504.519 143.893L503.278 145.05L503.396 145.177L504.637 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.197 144.019L517.079 143.893L515.838 145.05L515.956 145.177L517.197 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.758 144.019L529.64 143.893L528.399 145.05L528.517 145.177L529.758 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.318 144.019L542.2 143.893L540.959 145.05L541.078 145.177L542.318 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 144.019L554.76 143.893L553.52 145.05L553.638 145.177L554.879 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 144.019L567.321 143.893L566.08 145.05L566.199 145.177L567.44 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 144.019L579.882 143.893L578.641 145.05L578.759 145.177L580 144.019Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 156.584L2.09717 156.457L0.85622 157.614L0.974621 157.741L2.21497 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7757 156.584L14.6576 156.457L13.4166 157.614L13.5353 157.741L14.7757 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3361 156.584L27.2183 156.457L25.9773 157.614L26.0957 157.741L27.3361 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8968 156.584L39.7787 156.457L38.5377 157.614L38.6564 157.741L39.8968 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4572 156.584L52.3394 156.457L51.0985 157.614L51.2169 157.741L52.4572 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0185 156.584L64.9004 156.457L63.6595 157.614L63.7779 157.741L65.0185 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5792 156.584L77.4608 156.457L76.2202 157.614L76.3383 157.741L77.5792 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1396 156.584L90.0212 156.457L88.7806 157.614L88.899 157.741L90.1396 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.7 156.584L102.582 156.457L101.341 157.614L101.459 157.741L102.7 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.261 156.584L115.142 156.457L113.902 157.614L114.02 157.741L115.261 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.821 156.584L127.703 156.457L126.462 157.614L126.58 157.741L127.821 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.382 156.584L140.263 156.457L139.023 157.614L139.141 157.741L140.382 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.942 156.584L152.824 156.457L151.583 157.614L151.702 157.741L152.942 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.502 156.584L165.384 156.457L164.143 157.614L164.261 157.741L165.502 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.063 156.584L177.944 156.457L176.704 157.614L176.822 157.741L178.063 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.623 156.584L190.505 156.457L189.264 157.614L189.383 157.741L190.623 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.184 156.584L203.065 156.457L201.825 157.614L201.943 157.741L203.184 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.744 156.584L215.626 156.457L214.385 157.614L214.504 157.741L215.744 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.305 156.584L228.187 156.457L226.946 157.614L227.064 157.741L228.305 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.865 156.584L240.747 156.457L239.506 157.614L239.625 157.741L240.865 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.426 156.584L253.308 156.457L252.067 157.614L252.185 157.741L253.426 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.987 156.584L265.868 156.457L264.627 157.614L264.746 157.741L265.987 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.547 156.584L278.429 156.457L277.188 157.614L277.306 157.741L278.547 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.108 156.584L290.989 156.457L289.749 157.614L289.867 157.741L291.108 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.668 156.584L303.55 156.457L302.309 157.614L302.427 157.741L303.668 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.229 156.584L316.11 156.457L314.87 157.614L314.988 157.741L316.229 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.789 156.584L328.671 156.457L327.43 157.614L327.549 157.741L328.789 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.35 156.584L341.231 156.457L339.991 157.614L340.109 157.741L341.35 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.911 156.584L353.792 156.457L352.551 157.614L352.67 157.741L353.911 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.471 156.584L366.353 156.457L365.112 157.614L365.23 157.741L366.471 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.031 156.584L378.913 156.457L377.672 157.614L377.79 157.741L379.031 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.592 156.584L391.474 156.457L390.233 157.614L390.351 157.741L391.592 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.153 156.584L404.034 156.457L402.793 157.614L402.912 157.741L404.153 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.713 156.584L416.595 156.457L415.354 157.614L415.472 157.741L416.713 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.274 156.584L429.155 156.457L427.914 157.614L428.033 157.741L429.274 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.834 156.584L441.716 156.457L440.475 157.614L440.593 157.741L441.834 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.395 156.584L454.276 156.457L453.035 157.614L453.154 157.741L454.395 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.955 156.584L466.837 156.457L465.596 157.614L465.714 157.741L466.955 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.516 156.584L479.397 156.457L478.157 157.614L478.275 157.741L479.516 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.076 156.584L491.958 156.457L490.717 157.614L490.835 157.741L492.076 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.637 156.584L504.519 156.457L503.278 157.614L503.396 157.741L504.637 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.197 156.584L517.079 156.457L515.838 157.614L515.956 157.741L517.197 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.758 156.584L529.64 156.457L528.399 157.614L528.517 157.741L529.758 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.318 156.584L542.2 156.457L540.959 157.614L541.078 157.741L542.318 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 156.584L554.76 156.457L553.52 157.614L553.638 157.741L554.879 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 156.584L567.321 156.457L566.08 157.614L566.199 157.741L567.44 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 156.584L579.882 156.457L578.641 157.614L578.759 157.741L580 156.584Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 169.148L2.09717 169.022L0.85622 170.179L0.974621 170.306L2.21497 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7757 169.148L14.6576 169.022L13.4166 170.179L13.5353 170.306L14.7757 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3361 169.148L27.2183 169.022L25.9773 170.179L26.0957 170.306L27.3361 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8968 169.148L39.7787 169.022L38.5377 170.179L38.6564 170.306L39.8968 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4572 169.148L52.3394 169.022L51.0985 170.179L51.2169 170.306L52.4572 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0185 169.148L64.9004 169.022L63.6595 170.179L63.7779 170.306L65.0185 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5792 169.148L77.4608 169.022L76.2202 170.179L76.3383 170.306L77.5792 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1396 169.148L90.0212 169.022L88.7806 170.179L88.899 170.306L90.1396 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.7 169.148L102.582 169.022L101.341 170.179L101.459 170.306L102.7 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.261 169.148L115.142 169.022L113.902 170.179L114.02 170.306L115.261 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.821 169.148L127.703 169.022L126.462 170.179L126.58 170.306L127.821 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.382 169.148L140.263 169.022L139.023 170.179L139.141 170.306L140.382 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.942 169.148L152.824 169.022L151.583 170.179L151.702 170.306L152.942 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.502 169.148L165.384 169.022L164.143 170.179L164.261 170.306L165.502 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.063 169.148L177.944 169.022L176.704 170.179L176.822 170.306L178.063 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.623 169.148L190.505 169.022L189.264 170.179L189.383 170.306L190.623 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.184 169.148L203.065 169.022L201.825 170.179L201.943 170.306L203.184 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.744 169.148L215.626 169.022L214.385 170.179L214.504 170.306L215.744 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.305 169.148L228.187 169.022L226.946 170.179L227.064 170.306L228.305 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.865 169.148L240.747 169.022L239.506 170.179L239.625 170.306L240.865 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.426 169.148L253.308 169.022L252.067 170.179L252.185 170.306L253.426 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.987 169.148L265.868 169.022L264.627 170.179L264.746 170.306L265.987 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.547 169.148L278.429 169.022L277.188 170.179L277.306 170.306L278.547 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.108 169.148L290.989 169.022L289.749 170.179L289.867 170.306L291.108 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.668 169.148L303.55 169.022L302.309 170.179L302.427 170.306L303.668 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.229 169.148L316.11 169.022L314.87 170.179L314.988 170.306L316.229 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.789 169.148L328.671 169.022L327.43 170.179L327.549 170.306L328.789 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.35 169.148L341.231 169.022L339.991 170.179L340.109 170.306L341.35 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.911 169.148L353.792 169.022L352.551 170.179L352.67 170.306L353.911 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.471 169.148L366.353 169.022L365.112 170.179L365.23 170.306L366.471 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.031 169.148L378.913 169.022L377.672 170.179L377.79 170.306L379.031 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.592 169.148L391.474 169.022L390.233 170.179L390.351 170.306L391.592 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.153 169.148L404.034 169.022L402.793 170.179L402.912 170.306L404.153 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.713 169.148L416.595 169.022L415.354 170.179L415.472 170.306L416.713 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.274 169.148L429.155 169.022L427.914 170.179L428.033 170.306L429.274 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.834 169.148L441.716 169.022L440.475 170.179L440.593 170.306L441.834 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.395 169.148L454.276 169.022L453.035 170.179L453.154 170.306L454.395 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.955 169.148L466.837 169.022L465.596 170.179L465.714 170.306L466.955 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.516 169.148L479.397 169.022L478.157 170.179L478.275 170.306L479.516 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.076 169.148L491.958 169.022L490.717 170.179L490.835 170.306L492.076 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.637 169.148L504.519 169.022L503.278 170.179L503.396 170.306L504.637 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.197 169.148L517.079 169.022L515.838 170.179L515.956 170.306L517.197 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.758 169.148L529.64 169.022L528.399 170.179L528.517 170.306L529.758 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.318 169.148L542.2 169.022L540.959 170.179L541.078 170.306L542.318 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 169.148L554.76 169.022L553.52 170.179L553.638 170.306L554.879 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 169.148L567.321 169.022L566.08 170.179L566.199 170.306L567.44 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 169.148L579.882 169.022L578.641 170.179L578.759 170.306L580 169.148Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 181.713L2.09717 181.587L0.85622 182.744L0.974621 182.871L2.21497 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7757 181.713L14.6576 181.587L13.4166 182.744L13.5353 182.871L14.7757 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3361 181.713L27.2183 181.587L25.9773 182.744L26.0957 182.871L27.3361 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8968 181.713L39.7787 181.587L38.5377 182.744L38.6564 182.871L39.8968 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4572 181.713L52.3394 181.587L51.0985 182.744L51.2169 182.871L52.4572 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0185 181.713L64.9004 181.587L63.6595 182.744L63.7779 182.871L65.0185 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5792 181.713L77.4608 181.587L76.2202 182.744L76.3383 182.871L77.5792 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1396 181.713L90.0212 181.587L88.7806 182.744L88.899 182.871L90.1396 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.7 181.713L102.582 181.587L101.341 182.744L101.459 182.871L102.7 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.261 181.713L115.142 181.587L113.902 182.744L114.02 182.871L115.261 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.821 181.713L127.703 181.587L126.462 182.744L126.58 182.871L127.821 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.382 181.713L140.263 181.587L139.023 182.744L139.141 182.871L140.382 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.942 181.713L152.824 181.587L151.583 182.744L151.702 182.871L152.942 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.502 181.713L165.384 181.587L164.143 182.744L164.261 182.871L165.502 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.063 181.713L177.944 181.587L176.704 182.744L176.822 182.871L178.063 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.623 181.713L190.505 181.587L189.264 182.744L189.383 182.871L190.623 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.184 181.713L203.065 181.587L201.825 182.744L201.943 182.871L203.184 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.744 181.713L215.626 181.587L214.385 182.744L214.504 182.871L215.744 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.305 181.713L228.187 181.587L226.946 182.744L227.064 182.871L228.305 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.865 181.713L240.747 181.587L239.506 182.744L239.625 182.871L240.865 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.426 181.713L253.308 181.587L252.067 182.744L252.185 182.871L253.426 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.987 181.713L265.868 181.587L264.627 182.744L264.746 182.871L265.987 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.547 181.713L278.429 181.587L277.188 182.744L277.306 182.871L278.547 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.108 181.713L290.989 181.587L289.749 182.744L289.867 182.871L291.108 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.668 181.713L303.55 181.587L302.309 182.744L302.427 182.871L303.668 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.229 181.713L316.11 181.587L314.87 182.744L314.988 182.871L316.229 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.789 181.713L328.671 181.587L327.43 182.744L327.549 182.871L328.789 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.35 181.713L341.231 181.587L339.991 182.744L340.109 182.871L341.35 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.911 181.713L353.792 181.587L352.551 182.744L352.67 182.871L353.911 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.471 181.713L366.353 181.587L365.112 182.744L365.23 182.871L366.471 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.031 181.713L378.913 181.587L377.672 182.744L377.79 182.871L379.031 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.592 181.713L391.474 181.587L390.233 182.744L390.351 182.871L391.592 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.153 181.713L404.034 181.587L402.793 182.744L402.912 182.871L404.153 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.713 181.713L416.595 181.587L415.354 182.744L415.472 182.871L416.713 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.274 181.713L429.155 181.587L427.914 182.744L428.033 182.871L429.274 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.834 181.713L441.716 181.587L440.475 182.744L440.593 182.871L441.834 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.395 181.713L454.276 181.587L453.035 182.744L453.154 182.871L454.395 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.955 181.713L466.837 181.587L465.596 182.744L465.714 182.871L466.955 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.516 181.713L479.397 181.587L478.157 182.744L478.275 182.871L479.516 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.076 181.713L491.958 181.587L490.717 182.744L490.835 182.871L492.076 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.637 181.713L504.519 181.587L503.278 182.744L503.396 182.871L504.637 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.197 181.713L517.079 181.587L515.838 182.744L515.956 182.871L517.197 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.758 181.713L529.64 181.587L528.399 182.744L528.517 182.871L529.758 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.318 181.713L542.2 181.587L540.959 182.744L541.078 182.871L542.318 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 181.713L554.76 181.587L553.52 182.744L553.638 182.871L554.879 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 181.713L567.321 181.587L566.08 182.744L566.199 182.871L567.44 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 181.713L579.882 181.587L578.641 182.744L578.759 182.871L580 181.713Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 194.278L2.09717 194.151L0.85622 195.308L0.974621 195.436L2.21497 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7757 194.278L14.6576 194.151L13.4166 195.308L13.5353 195.436L14.7757 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3361 194.278L27.2183 194.151L25.9773 195.308L26.0957 195.436L27.3361 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8968 194.278L39.7787 194.151L38.5377 195.308L38.6564 195.436L39.8968 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4572 194.278L52.3394 194.151L51.0985 195.308L51.2169 195.436L52.4572 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0185 194.278L64.9004 194.151L63.6595 195.308L63.7779 195.436L65.0185 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5792 194.278L77.4608 194.151L76.2202 195.308L76.3383 195.436L77.5792 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1396 194.278L90.0212 194.151L88.7806 195.308L88.899 195.436L90.1396 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.7 194.278L102.582 194.151L101.341 195.308L101.459 195.436L102.7 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.261 194.278L115.142 194.151L113.902 195.308L114.02 195.436L115.261 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.821 194.278L127.703 194.151L126.462 195.308L126.58 195.436L127.821 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.382 194.278L140.263 194.151L139.023 195.308L139.141 195.436L140.382 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.942 194.278L152.824 194.151L151.583 195.308L151.702 195.436L152.942 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.502 194.278L165.384 194.151L164.143 195.308L164.261 195.436L165.502 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.063 194.278L177.944 194.151L176.704 195.308L176.822 195.436L178.063 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.623 194.278L190.505 194.151L189.264 195.308L189.383 195.436L190.623 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.184 194.278L203.065 194.151L201.825 195.308L201.943 195.436L203.184 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.744 194.278L215.626 194.151L214.385 195.308L214.504 195.436L215.744 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.305 194.278L228.187 194.151L226.946 195.308L227.064 195.436L228.305 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.865 194.278L240.747 194.151L239.506 195.308L239.625 195.436L240.865 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.426 194.278L253.308 194.151L252.067 195.308L252.185 195.436L253.426 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.987 194.278L265.868 194.151L264.627 195.308L264.746 195.436L265.987 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.547 194.278L278.429 194.151L277.188 195.308L277.306 195.436L278.547 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.108 194.278L290.989 194.151L289.749 195.308L289.867 195.436L291.108 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.668 194.278L303.55 194.151L302.309 195.308L302.427 195.436L303.668 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.229 194.278L316.11 194.151L314.87 195.308L314.988 195.436L316.229 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.789 194.278L328.671 194.151L327.43 195.308L327.549 195.436L328.789 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.35 194.278L341.231 194.151L339.991 195.308L340.109 195.436L341.35 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.911 194.278L353.792 194.151L352.551 195.308L352.67 195.436L353.911 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.471 194.278L366.353 194.151L365.112 195.308L365.23 195.436L366.471 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.031 194.278L378.913 194.151L377.672 195.308L377.79 195.436L379.031 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.592 194.278L391.474 194.151L390.233 195.308L390.351 195.436L391.592 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.153 194.278L404.034 194.151L402.793 195.308L402.912 195.436L404.153 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.713 194.278L416.595 194.151L415.354 195.308L415.472 195.436L416.713 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.274 194.278L429.155 194.151L427.914 195.308L428.033 195.436L429.274 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.834 194.278L441.716 194.151L440.475 195.308L440.593 195.436L441.834 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.395 194.278L454.276 194.151L453.035 195.308L453.154 195.436L454.395 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.955 194.278L466.837 194.151L465.596 195.308L465.714 195.436L466.955 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.516 194.278L479.397 194.151L478.157 195.308L478.275 195.436L479.516 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.076 194.278L491.958 194.151L490.717 195.308L490.835 195.436L492.076 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.637 194.278L504.519 194.151L503.278 195.308L503.396 195.436L504.637 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.197 194.278L517.079 194.151L515.838 195.308L515.956 195.436L517.197 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.758 194.278L529.64 194.151L528.399 195.308L528.517 195.436L529.758 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.318 194.278L542.2 194.151L540.959 195.308L541.078 195.436L542.318 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 194.278L554.76 194.151L553.52 195.308L553.638 195.436L554.879 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 194.278L567.321 194.151L566.08 195.308L566.199 195.436L567.44 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 194.278L579.882 194.151L578.641 195.308L578.759 195.436L580 194.278Z"
      fill="#D5D7DA"
    />
    <path
      d="M2.21497 206.842L2.09717 206.716L0.85622 207.873L0.974621 208L2.21497 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M14.7757 206.842L14.6576 206.716L13.4166 207.873L13.5353 208L14.7757 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M27.3361 206.842L27.2183 206.716L25.9773 207.873L26.0957 208L27.3361 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M39.8968 206.842L39.7787 206.716L38.5377 207.873L38.6564 208L39.8968 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M52.4572 206.842L52.3394 206.716L51.0985 207.873L51.2169 208L52.4572 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M65.0185 206.842L64.9004 206.716L63.6595 207.873L63.7779 208L65.0185 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M77.5792 206.842L77.4608 206.716L76.2202 207.873L76.3383 208L77.5792 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M90.1396 206.842L90.0212 206.716L88.7806 207.873L88.899 208L90.1396 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M102.7 206.842L102.582 206.716L101.341 207.873L101.459 208L102.7 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M115.261 206.842L115.142 206.716L113.902 207.873L114.02 208L115.261 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M127.821 206.842L127.703 206.716L126.462 207.873L126.58 208L127.821 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M140.382 206.842L140.263 206.716L139.023 207.873L139.141 208L140.382 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M152.942 206.842L152.824 206.716L151.583 207.873L151.702 208L152.942 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M165.502 206.842L165.384 206.716L164.143 207.873L164.261 208L165.502 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M178.063 206.842L177.944 206.716L176.704 207.873L176.822 208L178.063 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M190.623 206.842L190.505 206.716L189.264 207.873L189.383 208L190.623 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M203.184 206.842L203.065 206.716L201.825 207.873L201.943 208L203.184 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M215.744 206.842L215.626 206.716L214.385 207.873L214.504 208L215.744 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M228.305 206.842L228.187 206.716L226.946 207.873L227.064 208L228.305 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M240.865 206.842L240.747 206.716L239.506 207.873L239.625 208L240.865 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M253.426 206.842L253.308 206.716L252.067 207.873L252.185 208L253.426 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M265.987 206.842L265.868 206.716L264.627 207.873L264.746 208L265.987 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M278.547 206.842L278.429 206.716L277.188 207.873L277.306 208L278.547 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M291.108 206.842L290.989 206.716L289.749 207.873L289.867 208L291.108 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M303.668 206.842L303.55 206.716L302.309 207.873L302.427 208L303.668 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M316.229 206.842L316.11 206.716L314.87 207.873L314.988 208L316.229 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M328.789 206.842L328.671 206.716L327.43 207.873L327.549 208L328.789 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M341.35 206.842L341.231 206.716L339.991 207.873L340.109 208L341.35 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M353.911 206.842L353.792 206.716L352.551 207.873L352.67 208L353.911 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M366.471 206.842L366.353 206.716L365.112 207.873L365.23 208L366.471 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M379.031 206.842L378.913 206.716L377.672 207.873L377.79 208L379.031 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M391.592 206.842L391.474 206.716L390.233 207.873L390.351 208L391.592 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M404.153 206.842L404.034 206.716L402.793 207.873L402.912 208L404.153 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M416.713 206.842L416.595 206.716L415.354 207.873L415.472 208L416.713 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M429.274 206.842L429.155 206.716L427.914 207.873L428.033 208L429.274 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M441.834 206.842L441.716 206.716L440.475 207.873L440.593 208L441.834 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M454.395 206.842L454.276 206.716L453.035 207.873L453.154 208L454.395 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M466.955 206.842L466.837 206.716L465.596 207.873L465.714 208L466.955 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M479.516 206.842L479.397 206.716L478.157 207.873L478.275 208L479.516 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M492.076 206.842L491.958 206.716L490.717 207.873L490.835 208L492.076 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M504.637 206.842L504.519 206.716L503.278 207.873L503.396 208L504.637 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M517.197 206.842L517.079 206.716L515.838 207.873L515.956 208L517.197 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M529.758 206.842L529.64 206.716L528.399 207.873L528.517 208L529.758 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M542.318 206.842L542.2 206.716L540.959 207.873L541.078 208L542.318 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M554.879 206.842L554.76 206.716L553.52 207.873L553.638 208L554.879 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M567.44 206.842L567.321 206.716L566.08 207.873L566.199 208L567.44 206.842Z"
      fill="#D5D7DA"
    />
    <path
      d="M580 206.842L579.882 206.716L578.641 207.873L578.759 208L580 206.842Z"
      fill="#D5D7DA"
    />
  </svg>
);

export default UnionPattern;
